import { addDays } from "date-fns";
import _ from "lodash";
import ReactDOM from "react-dom";
import {
  MDBAlert,
  MDBBadge,
  MDBBtn,
  MDBCard,
  MDBCardBody,
  MDBCardText,
  MDBCardTitle,
  MDBCol,
  MDBIcon,
  MDBInput,
  MDBModal,
  MDBModalBody,
  MDBModalFooter,
  MDBModalHeader,
  MDBRow,
  MDBSelect,
  MDBTable,
  MDBTableBody,
  MDBTableHead,
  MDBBtnFixedItem,
  MDBCollapseHeader,
  MDBCollapse,
  MDBBtnFixed,
} from "mdbreact";
import moment, { utc } from "moment";
import queryString from "query-string";
import React from "react";
import Autocomplete from "react-autocomplete";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import CustomDataGrid from "./CustomDataGrid";
import IdleTimer from "react-idle-timer";

import {
  alert as DevExtremeAlert,
  confirm as DevExtremeConfirm,
} from "devextreme/ui/dialog";

import {
  clearNotification,
  selectDate,
  showHideLoader,
  showNotification,
  toggleModal,
  closeBooking,
  bookingChangeSchedule,
} from "../../../actions";
import {
  clearBookingFailedResponse,
  clearBookingStatusFailedResponse,
  clearBookingStatusSuccessResponse,
  clearBookingSuccessResponse,
  clearStatusFailedResponse,
  clearStatusSuccessResponse,
  doBooking,
  getBookingStatus,
  getStatuses,
  setBookingDetails,
  updateBooking,
  checkBookingConflicts,
  getUserCalendar,
} from "../../../actions/bookingAction";
import { getCustomers } from "../../../actions/customerAction";
import {
  getLocationList,
  // getLocationResources,
  // getLocationResourcesPrivate,
  searchLocations,
} from "../../../actions/locationAction";
import { calculatePrice, requestPayment } from "../../../actions/paymentAction";
import {
  clearGenCustomerVoucherFailedResponse,
  clearGenCustomerVoucherSuccessResponse,
  generateCustomerVoucher,
} from "../../../actions/voucherAction";
import websocketApi from "../../../apis/websocketApi";
import {
  roundNumber,
  extractTimezone,
  getBookingColors,
  getCss,
  validateAccess,
} from "../../../helper/utils";
import Switch from "./Switch";
import SectionContainer from "./sectionContainer";
import BookingEditor from "./BookingEditor";
import { subscribe } from "../../../actions/userAction";
import { getResource } from "../../../actions/resourceAction";

class MyCalendar extends React.Component {
  maxBookingParticipants = 0;
  isCanRefresh = false;

  constructor(props) {
    super(props);
    this.participantUniqueValidation =
      this.participantUniqueValidation.bind(this);
    this.modal = React.createRef();
    this.rowValidating = this.rowValidating.bind(this);
    this.triggerEvent = this.triggerEvent.bind(this);
    this.triggerDeletedEvent = this.triggerDeletedEvent.bind(this);
    this.triggerInsertEvent = this.triggerInsertEvent.bind(this);
    this.toolbarItemRender = this.toolbarItemRender.bind(this);
    this.allowDeletingParticipant = this.allowDeletingParticipant.bind(this);
    this.allowUpdatingParticipant = this.allowUpdatingParticipant.bind(this);
    this.handleOnAction = this.handleOnAction.bind(this);
    this.handleOnActive = this.handleOnActive.bind(this);
    this.handleOnIdle = this.handleOnIdle.bind(this);

    if (
      typeof props.isChangeSchedule !== "undefined" &&
      props.isChangeSchedule
    ) {
      this.props.location.search = `uuid=${props.locationUuid}`;
      this.state.isChangeSchedule = props.isChangeSchedule;
    }

    this.selectedDateVar = new Date();
    this.props.selectDate(new Date());

    if (
      typeof props.showCalendarSelect == "undefined" ||
      props.showCalendarSelect
    ) {
      this.startCalendarRefresh();
    }
  }

  handleOnAction(event) {}

  handleOnActive(event) {
    this.props.showHideLoader(true);
    this.startCalendarRefresh();
  }

  handleOnIdle(event) {
    clearInterval(this.intervalId);
  }

  state = {
    alert: {
      type: "",
      title: "",
      text: "",
      clearAfter: false,
    },
    isLocationPerMembership: false,
    activeItemOuterTabs: "1",
    activeItemInnerPills: "1",
    private: this.props.private,
    courtTypeOptions: [],
    surfaceTypeOptions: [],
    searchDateVal: moment(new Date()).format("YYYY-MM-DD"),
    // searchDateVal: "2020-07-25",
    isClientSideFilter: false,
    ClientSidefilterCompleted: false,
    locationResourcesContainer: {},
    origLocationResourcesContainer: {},
    doDropdownFilter: false,
    selectedResource: "Select Resource Type",
    selectedSurface: "Select Surface Type",
    dropdownCounter: 0,
    showBookingDetailsModal: false,
    selectedBookingDetails: {},
    showBookingModal: false,

    customerId: "",
    first_name: "",
    last_name: "",
    email: "",
    mobile: "",
    address: "",
    invoice: "",
    paid: false,
    notes: "",
    selectedBooking: {},
    duration: "",
    origTime: "",
    time: "",
    paymentMethod: "Credit Card",
    isRecurring: false,
    frequencyInWeeks: "Weekly",
    totalPrice: 0,
    origPrice: 0,
    doneGettingOriginalPrice: false,
    showPriceChangeWarning: false,
    chargeAmount: 0,
    lessAmount: 0,
    totalAmount: 0,

    wasValidated: "",
    isInitialPriceComputed: false,

    coupon: "",
    couponErrorMsg: "",
    invalidCoupon: false,
    couponDiscount: 0,

    durationDefaultVal: 30,

    discountAmount: 0,
    receiptUrl: "",
    vendor: "",

    bookingRef: "",
    bookingUuid: "",
    bookingId: "",

    locationId: "",
    locationUuid: "",
    locationName: "",

    resourceId: "",
    resourceUuid: "",
    resourceName: "",

    customerId: "",
    customerUuid: "",

    origStatus: "",
    status: "",
    statusDesc: "",
    statusChangeConfirmation: "",

    statusNotes: "",
    isUpdate: false,

    isChargable: 0,
    issueVoucher: 0,
    isOverrideble: 0,
    getAvailableSlot: [],

    generatedTimeContainer: [],
    tableElem: [],
    tableElemForMobile: false,

    paymentTransaction: {},

    paymentHistoryElem: [],
    bookingStatusHistoryElem: [],

    disableStatusButton: false,

    generateVoucher: false,

    disableSaveButton: false,

    showRecurringWarning: false,
    origSearchDateVal: "",

    showCalendarSelect: false,
    updateSchedule: false,

    locationObj: {},
    locationTimezone: undefined,
    bookingColors: getBookingColors(undefined),

    showExceedMaxDurationAcknowledge: false,
    maxDuration: 0,
    maxDurationInText: "",
    checkMoreThanMaxDuration: false,
    customerResultContainer: [],

    isDateFilter: false,

    recurringFrequencies: {
      Weekly: 7,
      Fortnightly: 14,
      Monthly: 28,
    },
    endDate: "",

    calendarPrevNavDisable: false,
    calendarNextNavDisable: false,
    isConflictLoaded: false,
    participants: [],
    collapseID: "",
    modalCollapseID: "collapse1",

    buttonStyle: {
      transform: "scaleY(0.4) scaleX(0.4) translateY(40px) translateX(0)",
      opacity: "0",
    },
    isScrolling: false,
    isDefaultUser: false,
    readOnlyEmail: false,
    defaultCustomer: {},
    allowLocResourcePublicBooking: "No",
    overwriteFee: false,
    overwriteFeeAmount: "",
    switchCalendar: true,

    minTime: "07:00",
    maxTime: "22:00",
    userCalendarLimit: 200,
    locationResource: {},
  };

  participantUniqueValidation(data) {
    let result = _.find(this.state.participants, function (o) {
      return o.email == data.value && data.value != "" && o.id != data.data.id;
    });
    return result == undefined || result.length == 0;
  }

  rowValidating(e) {
    let editableFields = ["first_name", "last_name", "email", "mobile"];
    editableFields.forEach((column, index) => {
      e.component.focus();
      if (e.data.email == this.state.email && !this.props.isView) {
        e.component.columnOption(column).formItem.cssClass =
          "dx-cell-focus-disabled dx-state-readonly disabled";
      } else {
        e.component.columnOption(column).formItem.cssClass = "";
      }
    });
    //e.component.focus();
    return e;
  }

  triggerEvent = (e) => {
    let { participants, isLocationPerMembership } = this.state;

    let data = { ...e.key, ...e.newData };
    let key = data.__KEY__;
    if (typeof data.__KEY__ == "undefined") {
      key = data.id;
    }

    if (data["checked_in"]) {
      e.newData["checked_in_time"] = data["checked_in_time"] = moment()
        .local(this.getTzDetails().timezone)
        .format("YYYY-MM-DD HH:mm:ss");
    } else if (data["checked_in"] == 0) {
      data["checked_in_time"] = "";
    }

    if (typeof data.is_primary != "undefined" && data.is_primary) {
      this.setState({
        ...this.state,
        ...data,
      });
    }

    let participantIndex = _.findIndex(participants, function (o) {
      return o.id == key;
    });
    if (participantIndex < 0) {
      participants.push(data);
    } else {
      participants[participantIndex] = data;
    }

    this.state.participants = participants;

    if (isLocationPerMembership) {
      this.calculatePrice();
    }
    return false;
  };

  triggerDeletedEvent = (e) => {
    let { participants, isLocationPerMembership } = this.state;
    let data = e.key;
    let key = data.__KEY__;
    if (typeof data.__KEY__ == "undefined") {
      key = data.id;
    }

    let participantIndex = _.findIndex(participants, function (o) {
      return o.id == key;
    });

    participants.splice(participantIndex, 1);

    this.state.participants = participants;

    if (isLocationPerMembership) {
      this.calculatePrice();
    }

    return false;
  };

  triggerInsertEvent = (e) => {
    let { participants, isLocationPerMembership } = this.state;
    let data = e.data;
    let key = data.__KEY__;
    data["id"] = key;
    delete data.__KEY__;

    if (data["checked_in"]) {
      data["checked_in_time"] = moment()
        .local(this.getTzDetails().timezone)
        .format("YYYY-MM-DD HH:mm:ss");
    } else if (data["checked_in"] == 0) {
      data["checked_in_time"] = "";
    }
    let participantIndex = _.findIndex(participants, function (o) {
      return o.id == key;
    });
    if (participantIndex < 0) {
      participants.push(data);
    } else {
      participants[participantIndex] = data;
    }

    this.state.participants = participants;

    if (isLocationPerMembership) {
      this.calculatePrice();
    }
    return false;
  };

  getRandomInt(min, max) {
    return Math.floor(Math.random() * (max - min + 1) + min);
  }

  debouncedSelectedDate = _.debounce(function (date) {
    let formattedDate = moment(date).format("YYYY-MM-DD");

    const days_in_advance = this.days_in_advance;
    let calendarNextNavDisable = this.state.calendarNextNavDisable;
    if (days_in_advance && this.state.isDefaultUser) {
      let daysAdvance = moment(new Date())
        .add(days_in_advance, "days")
        .format("YYYY-MM-DD");
      let dt = moment(date).add(1, "days").format("YYYY-MM-DD");
      if (daysAdvance < formattedDate) {
        return;
      }
      calendarNextNavDisable = dt > daysAdvance;
    }

    this.selectedDateVar = date;

    this.props.selectDate(date);

    this.overrideCalendarNextNavDisable = calendarNextNavDisable;

    this.setState({
      searchDateVal: formattedDate,
      isClientSideFilter: false,
      ClientSidefilterCompleted: false,
      isDateFilter: true,
      calendarNextNavDisable: calendarNextNavDisable,
    });

    if (this.state.private) {
      this.doSwitchCalendar(
        this.state.switchCalendar,
        this.state.searchDateVal
      );
    }
  }, 500);

  dateOnChange = (date) => {
    this.setState({
      isClientSideFilter: false,
      ClientSidefilterCompleted: false,
      locationResourcesLoaded: false,
    });
    this.debouncedSelectedDate(date);
    this.doSwitchCalendar(this.state.switchCalendar, date);
  };

  datePicker() {
    if (this.state.private) {
      return (
        <div>
          <DatePicker
            key={this.days_in_advance}
            className="custom-input"
            placeholderText="Click here"
            // minDate={new Date()}
            maxDate={
              this.days_in_advance && addDays(new Date(), this.days_in_advance)
            }
            clear
            selected={this.props.selectedDate}
            onChange={this.dateOnChange}
            onInputClick={() => this.clearRefreshCalendarTimer()}
            dateFormat="dd/MM/yyyy"
          />
        </div>
      );
    } else {
      return (
        <div>
          <DatePicker
            className="custom-input"
            placeholderText="Click here"
            minDate={new Date()}
            maxDate={addDays(new Date(), 30)}
            selected={this.props.selectedDate}
            onChange={this.dateOnChange}
            onInputClick={() => this.clearRefreshCalendarTimer()}
            dateFormat="dd/MM/yyyy"
          />
        </div>
      );
    }
  }

  getValueOfSelectCourtType = (value) => {
    if (this.state.doDropdownFilter) {
      this.setState({
        isClientSideFilter: true,
        selectedResource: value,
        ClientSidefilterCompleted: false,
      });
    }
  };

  getValueOfSelectSurfaceType = (value) => {
    if (this.state.doDropdownFilter) {
      this.setState({
        isClientSideFilter: true,
        selectedSurface: value,
        ClientSidefilterCompleted: false,
      });
    }
  };

  filterEnable = () => {
    this.setState({ doDropdownFilter: true });
  };

  handleSwitchCalendar = (state) => {
    this.doSwitchCalendar(state, this.props.selectedDate);
    this.setState({ switchCalendar: state });
  };

  doSwitchCalendar(isDay, ddate) {
    let tz = this.getTzDetails(ddate);
    let selectedDate = moment(ddate).format("YYYY-MM-DD");
    let from =
      moment(selectedDate + "T" + this.state.minTime + tz.offset)
        .utc()
        .format()
        .substring(0, 19) + "Z";

    let to =
      moment(selectedDate + "T" + this.state.maxTime + tz.offset)
        .utc()
        .format()
        .substring(0, 19) + "Z";

    if (!isDay) {
      var startOfWeek = moment(ddate).startOf("isoWeek").format("YYYY-MM-DD");
      var endOfWeek = moment(ddate).endOf("isoWeek").format("YYYY-MM-DD");
      from =
        moment(startOfWeek + "T" + this.state.minTime + tz.offset)
          .utc()
          .format()
          .substring(0, 19) + "Z";

      to =
        moment(endOfWeek + "T" + this.state.maxTime + tz.offset)
          .utc()
          .format()
          .substring(0, 19) + "Z";
    }

    this.getUserCalendar({
      limit: this.state.userCalendarLimit,
      page: 0,
      startDate: from,
      endDate: to,
    });
  }

  headerSection() {
    return (
      <div className={`calendarHeader`}>
        <MDBRow>
          <MDBCol md="12">
            <MDBRow className="">
              <MDBCol md="3">
                <span className="custom-label">Select Date</span>
                {this.datePicker()}
              </MDBCol>
              <MDBCol md="9">
                <div className="float-right goToTodayCont">
                  {/* {this.renderSubscribeButton()} */}
                  <Switch onSwitch={this.handleSwitchCalendar} />
                  <MDBBtn
                    className="goToToday"
                    size="sm"
                    onClick={() => this.doGoToToday()}
                    onMouseEnter={() => this.clearRefreshCalendarTimer()}
                  >
                    Go to Today
                  </MDBBtn>
                </div>
              </MDBCol>
            </MDBRow>
          </MDBCol>
        </MDBRow>
      </div>
    );
  }

  statusIndicator() {
    const { bookingColors } = this.state;
    if (!this.state.private) {
      return (
        <div>
          <div>
            <MDBBadge className={getCss(bookingColors.bg_public_available)}>
              <span className={getCss(bookingColors.tc_public_available)}>
                Available
              </span>
            </MDBBadge>
            <MDBBadge className={getCss(bookingColors.bg_public_booked)}>
              <span className={getCss(bookingColors.tc_public_booked)}>
                Booked
              </span>
            </MDBBadge>
            <MDBBadge className={getCss(bookingColors.bg_public_notAvailable)}>
              <span className={getCss(bookingColors.tc_public_notAvailable)}>
                Not available
              </span>
            </MDBBadge>
          </div>
          <span className="info-label">Click available block to book</span>
        </div>
      );
    } else {
      // if (bookingColors !== undefined) {
      return (
        <div>
          <div>
            <MDBBadge className={getCss(bookingColors.bg_available)}>
              <span className={getCss(bookingColors.tc_available)}>
                No schedule
              </span>
            </MDBBadge>
            <MDBBadge className={getCss(bookingColors.bg_oneOff)}>
              <span className={getCss(bookingColors.tc_oneOff)}>One Off</span>
            </MDBBadge>

            <MDBBadge className={getCss(bookingColors.bg_maintenance)}>
              <span className={getCss(bookingColors.tc_maintenance)}>
                Maintenance
              </span>
            </MDBBadge>
            <MDBBadge className={getCss(bookingColors.bg_coachingSession)}>
              <span className={getCss(bookingColors.tc_coachingSession)}>
                Coaching Session
              </span>
            </MDBBadge>
            <MDBBadge className={getCss(bookingColors.bg_notAvailable)}>
              <span className={getCss(bookingColors.tc_notAvailable)}>
                Not available
              </span>
            </MDBBadge>
          </div>
          <span className="info-label">Click available block to book</span>
        </div>
      );
      // }
      return <></>;
    }
  }

  modalConfig = () => {
    const modal = {
      isOpen: false,
      content: "",
      title: "Confirmation",
      negativeButtonText: "Cancel",
      positiveButtonText: "Checkout",
    };
    this.props.toggleModal(modal);
  };

  checkout() {
    this.props.history.push("/checkout");
  }

  getAvailableSlotOld(resourceId, time) {
    let resource = _.chain(this.props.locationResources.results)
      .map((resource) => {
        if (resource.uuid === resourceId) {
          return resource;
        }
        return [];
      })
      .filter(_.size)
      .value()[0];

    let minDuration = parseInt(
      resource.attributes.min_duration.replace("m", "")
    );
    let maxDuration = parseInt(
      resource.attributes.max_duration.replace("m", "")
    );

    let remainingDuration = maxDuration - minDuration;

    let minTime = moment(_.split(time, "-"[1]), "HH:mm")
      .add(30, "minutes")
      .format("HH:mm");

    let maxTime = moment(_.split(time, "-"[1]), "HH:mm")
      .add(maxDuration, "minutes")
      .format("HH:mm");

    let addedTime = minTime;

    let formattedTimeArr = [];
    let toFormatObj = {};

    let counter = 0;
    while (addedTime !== maxTime) {
      counter++;
      if (counter !== 1) {
        addedTime = moment(addedTime, "HH:mm")
          .add(30, "minutes")
          .format("HH:mm");
      }
      if (toFormatObj.start === undefined) {
        toFormatObj["start"] = addedTime;
      } else if (
        toFormatObj.start !== undefined &&
        toFormatObj.end === undefined
      ) {
        toFormatObj["end"] = addedTime;
      }

      if (toFormatObj.start !== undefined && toFormatObj.end !== undefined) {
        formattedTimeArr.push(toFormatObj.start + "-" + toFormatObj.end);
        addedTime = toFormatObj.start;
        toFormatObj = {};
      }
    }

    let filteredFormattedTimeArr = [];

    for (let i = 0; i < formattedTimeArr.length; i++) {
      let isFound = false;
      _.map(resource.booking, (book) => {
        if (book.start_time === _.split(formattedTimeArr[i], "-")[0]) {
          isFound = true;
        }
      });

      if (!isFound) {
        filteredFormattedTimeArr.push(formattedTimeArr[i]);
      } else {
        break;
      }
    }

    return filteredFormattedTimeArr;
  }

  getAvailableSlot(resourceId, time) {
    let resource = _.chain(this.state.locationResourcesContainer.results)
      .map((resource) => {
        if (resource.uuid === resourceId) {
          return resource;
        }
        return [];
      })
      .filter(_.size)
      .value()[0];

    let minDuration = parseInt(
      resource.attributes.min_duration.replace("m", "")
    );
    let maxDuration = parseInt(
      resource.attributes.max_duration.replace("m", "")
    );

    let durationPerChunk = parseInt(
      resource.attributes.duration_per_chunk.replace("m", "")
    );

    let minTime = moment(_.split(time, "-")[0], "HH:mm")
      .add(minDuration, "minutes")
      .format("HH:mm");

    let maxTime = moment(_.split(time, "-")[0], "HH:mm")
      .add(maxDuration, "minutes")
      .format("HH:mm");

    if (
      maxTime > resource.attributes.default_end_time ||
      maxTime < resource.attributes.default_start_time
    ) {
      // This block means that if the maxTime is greater than default end time (22:30)
      // or maxTime is less than default start time 7:00
      // because previous  maxTime > resource.attributes.default_end_time is not working when the maxTime is 00:00
      maxTime = resource.attributes.default_end_time;
    }

    let addedTime = minTime;

    let formattedTimeArr = [];
    let toFormatObj = {};

    let counter = 0;
    while (addedTime !== maxTime) {
      counter++;
      if (counter !== 1) {
        addedTime = moment(addedTime, "HH:mm")
          .add(durationPerChunk, "minutes")
          .format("HH:mm");
      }
      if (toFormatObj.start === undefined) {
        toFormatObj["start"] = addedTime;
      } else if (
        toFormatObj.start !== undefined &&
        toFormatObj.end === undefined
      ) {
        toFormatObj["end"] = addedTime;
      }

      if (toFormatObj.start !== undefined && toFormatObj.end !== undefined) {
        formattedTimeArr.push(toFormatObj.start + "-" + toFormatObj.end);
        addedTime = toFormatObj.start;
        toFormatObj = {};
      }
    }

    let durationArr = [];

    // --set initial value
    durationArr.push(minDuration);

    let bookedStartTimeArr = _.chain(resource.bookings)
      .map((book) => {
        return moment(book.start_time)
          .tz(this.getTzDetails().timezone)
          .format("HH:mm");
      })
      .sort()
      .value();

    for (let i = 0; i < formattedTimeArr.length; i++) {
      let isFound = false;
      let formattedStartTime = _.split(formattedTimeArr[i], "-")[0];
      _.map(bookedStartTimeArr, (startTime) => {
        if (startTime === formattedStartTime) {
          isFound = true;
        }
      });

      if (!isFound) {
        durationArr.push(
          durationPerChunk + durationArr[durationArr.length - 1]
        );
      } else {
        break;
      }
    }

    return durationArr;
  }

  updateTimeValue(duration) {
    const { showBookingDetailsModal } = this.state;
    let origTime = this.state.origTime;
    let startTime = _.split(origTime, "-")[0];
    let endTime = moment(startTime, "HH:mm")
      .add(duration, "minutes")
      .format("HH:mm");

    this.setState({ time: startTime + "-" + endTime });
    this.validateShowExceedMaxDuration(
      duration,
      this.state.resourceUuid,
      showBookingDetailsModal
    );

    // this.computeTotalPrice(startTime, endTime);
  }

  onDurationChange = (evt) => {
    this.updateTimeValue(evt.target.value);
    this.setState({
      duration: evt.target.value,
      couponErrorMsg: "",
      invalidCoupon: false,
      couponDiscount: 0,
    });
  };

  getAvailableSlotPrivate(resourceId, time) {
    let tz = this.getTzDetails(new Date(this.state.searchDateVal));

    let resource = _.chain(this.state.locationResourcesContainer.results)
      .map((resource) => {
        if (resource.uuid === resourceId) {
          return resource;
        }
        return [];
      })
      .filter(_.size)
      .value()[0];

    let minDuration = parseInt(
      resource.attributes.min_duration.replace("m", "")
    );
    let maxDuration = parseInt(
      resource.attributes.max_duration.replace("m", "")
    );

    let durationPerChunk = parseInt(
      resource.attributes.duration_per_chunk.replace("m", "")
    );

    let minTime = moment(_.split(time, "-")[0], "HH:mm")
      .add(30, "minutes")
      .format("HH:mm");

    let maxTime = resource.attributes.default_end_time;

    let addedTime = minTime;

    let formattedTimeArr = [];
    let toFormatObj = {};

    let counter = 0;
    while (addedTime !== maxTime) {
      counter++;
      if (counter !== 1) {
        addedTime = moment(addedTime, "HH:mm")
          .add(durationPerChunk, "minutes")
          .format("HH:mm");
      }
      if (toFormatObj.start === undefined) {
        toFormatObj["start"] = addedTime;
      } else if (
        toFormatObj.start !== undefined &&
        toFormatObj.end === undefined
      ) {
        toFormatObj["end"] = addedTime;
      }

      if (toFormatObj.start !== undefined && toFormatObj.end !== undefined) {
        formattedTimeArr.push(toFormatObj.start + "-" + toFormatObj.end);
        addedTime = toFormatObj.start;
        toFormatObj = {};
      }
    }

    let durationArr = [];

    // --set initial value
    durationArr.push(30);

    let bookedStartTimeArr = _.chain(resource.bookings)
      .map((book) => {
        return {
          startTime: moment(book.start_time)
            .tz(this.getTzDetails().timezone)
            .format("HH:mm"),
          endTime: moment(book.end_time)
            .tz(this.getTzDetails().timezone)
            .format("HH:mm"),
          bookingRef: book.booking_reference,
        };
      })
      .orderBy(["startTime"], ["asc"])
      .value();

    let recurrings = resource.recurrings;
    for (let i = 0; i < formattedTimeArr.length; i++) {
      let isFound = false;
      let formattedStartTime = _.split(formattedTimeArr[i], "-")[0];
      _.map(bookedStartTimeArr, (bookTimeObj) => {
        if (
          this.state.bookingRef !== bookTimeObj.bookingRef &&
          bookTimeObj.startTime === formattedStartTime
        ) {
          isFound = true;
        }
      });

      if (!isFound) {
        _.map(recurrings, function (data) {
          let booking_from = moment(data.booking_from)
            .tz(tz.timezone)
            .format("HH:mm");
          if (!isFound && booking_from === formattedStartTime) {
            isFound = true;
          }
        });
      }

      if (!isFound) {
        durationArr.push(
          durationPerChunk + durationArr[durationArr.length - 1]
        );
      } else {
        break;
      }
    }

    return durationArr;
  }

  validateModal(paramData) {
    let genStartTime = _.split(paramData.time, "-")[0];
    let addedTime = genStartTime;
    let endTime = moment(paramData.defaultEndTime, "HH:mm")
      .subtract(30, "minutes")
      .format("HH:mm");
    if (genStartTime === endTime) {
      return false;
    } else {
      let bookedStartTimeArr = _.chain(paramData.bookings)
        .map((book) => {
          return moment(book.start_time)
            .tz(this.getTzDetails().timezone)
            .format("HH:mm");
        })
        .sort()
        .value();

      let maxTime = "";

      for (let i = 0; i < bookedStartTimeArr.length; i++) {
        if (
          moment(genStartTime, "HH:mm").isBefore(
            moment(bookedStartTimeArr[i], "HH:mm")
          )
        ) {
          maxTime = bookedStartTimeArr[i];
          break;
        }
      }
      if (maxTime.length > 0) {
        addedTime = moment(addedTime, "HH:mm")
          .add(30, "minutes")
          .format("HH:mm");

        if (addedTime == maxTime) {
          return false;
        } else {
          return true;
        }
      } else {
        return true;
      }
    }
  }

  openBookingDetailsModalForm = (book) => {
    this.props.getResource(
      book.resource.uuid,
      this.props.authUser.sessionToken
    );

    this.setState({
      selectedBookingDetails: book,
      // showBookingDetailsModal: true,
    });
  };

  getCustomerUniqueReference() {
    //get the logged in user on the participant list
    let loggedinUserEmail = this.props["authUser"]["username"];
    let customer = _.find(
      this.state["selectedBookingDetails"]["participants"],
      function (data) {
        return data["customer"]["email"] == loggedinUserEmail;
      }
    );

    //if the user is admin do not show the Unique reference on header
    let customerUniqueReference = "";
    if (!_.isEmpty(customer)) {
      customerUniqueReference = customer["booking_participant_reference"];
    }
    return customerUniqueReference;
  }

  toggleOuterTabs = (tab) => (e) => {
    const { activeItemOuterTabs2 } = this.state;
    if (activeItemOuterTabs2 !== tab) {
      this.setState({
        activeItemOuterTabs: tab,
      });
    }
  };

  toggleInnerPills = (tab) => (e) => {
    const { activeItemInnerPills } = this.state;
    if (activeItemInnerPills !== tab) {
      this.setState({
        activeItemInnerPills: tab,
      });
    }
  };

  buildPaymentHistory(paymentTransaction) {
    let paymentHistoryElem = [];
    paymentHistoryElem.push(
      <MDBTable responsive key="tablekey1">
        <MDBTableHead>
          <tr>
            <th>Transaction Type</th>
            <th>Payment Method</th>
            <th className="text-align-right">Amount</th>
            <th>Discount Code</th>
            <th className="text-align-right">Discount Amount</th>
            <th className="text-align-right">Total Amount</th>
            <th>Transaction Date</th>
            <th>Status</th>
            <th>Remarks</th>
          </tr>
        </MDBTableHead>
        <MDBTableBody>
          {paymentTransaction.payments.map((payment, index) => (
            <tr key={index}>
              <td key={index + "1"}>{payment.method.vendor}</td>
              <td key={index + "2"}>{payment.method.method}</td>
              <td key={index + "3"} className="text-align-right">
                ${roundNumber(payment.subTotalAmount, 2)}
              </td>
              <td key={index + "4"}>{payment.voucherCode}</td>
              <td key={index + "5"} className="text-align-right">
                ${roundNumber(payment.voucherCreditAmount, 2)}
              </td>
              <td key={index + "6"} className="text-align-right">
                ${roundNumber(payment.totalAmount, 2)}
              </td>
              <td key={index + "7"}>
                {moment(
                  _.split(payment.paymentDate, " ")[0] +
                    "T" +
                    _.split(payment.paymentDate, " ")[1] +
                    "Z",
                  "YYYY-MM-DDTHH:mm:ssZ"
                )
                  .tz(this.getTzDetails().timezone)
                  .format("DD/MM/YYYY HH:mm:ss")}
              </td>
              <td key={index + "8"}>{payment.status}</td>
              <td key={index + "9"}>{payment.comments}</td>
            </tr>
          ))}
        </MDBTableBody>
      </MDBTable>
    );
    return paymentHistoryElem;
  }

  renderPaymentHistory() {
    const { paymentHistoryElem } = this.state;
    if (paymentHistoryElem.length > 0) {
      return <div>{paymentHistoryElem}</div>;
    }
    return <span></span>;
  }

  buildStatusHistory(getBookingStatusSuccessResponse) {
    let bookingStatusHistoryElem = [];
    bookingStatusHistoryElem.push(
      <MDBTable responsive scrollY key="sttable1">
        <MDBTableHead>
          <tr>
            <th>Status</th>
            <th>Date</th>
            <th>Remarks</th>
          </tr>
        </MDBTableHead>
        <MDBTableBody>
          {getBookingStatusSuccessResponse.data.history.map(
            (history, index) => (
              <tr key={index}>
                <td key={index + "1"}>{history.status}</td>
                <td key={index + "7"}>
                  {moment(
                    _.split(history.submittedDate, " ")[0] +
                      "T" +
                      _.split(history.submittedDate, " ")[1] +
                      "Z",
                    "YYYY-MM-DDTHH:mm:ssZ"
                  )
                    .tz(this.getTzDetails().timezone)
                    .format("DD/MM/YYYY HH:mm:ss")}
                </td>
                <td key={index + "9"}>{history.comments}</td>
              </tr>
            )
          )}
        </MDBTableBody>
      </MDBTable>
    );

    return bookingStatusHistoryElem;
  }

  renderStatusHistory() {
    const { bookingStatusHistoryElem } = this.state;
    if (bookingStatusHistoryElem.length > 0) {
      return <div>{bookingStatusHistoryElem}</div>;
    }
    return <span></span>;
  }

  validateStatusChangeButton() {
    const { isChargable, isOverrideble, issueVoucher, disableStatusButton } =
      this.state;
    return (
      <div>
        {isOverrideble === 1 && (
          <MDBBtn
            color="info"
            className="float-right"
            disabled={disableStatusButton}
            type="submit"
            onClick={this.doStatusChange("issueVoucher")}
          >
            Issue Voucher
          </MDBBtn>
        )}
        {isChargable === 1 && (
          <MDBBtn
            color="info"
            className="float-right"
            disabled={disableStatusButton}
            type="submit"
            onClick={this.doStatusChange("charge")}
          >
            Charge
          </MDBBtn>
        )}
        {issueVoucher === 1 && (
          <MDBBtn
            color="info"
            className="float-right"
            disabled={disableStatusButton}
            type="submit"
            onClick={this.doStatusChange("issueVoucher")}
          >
            Issue Voucher
          </MDBBtn>
        )}
      </div>
    );
  }

  isBookingStatusChangeFailed() {
    if (
      (this.props.genCustomerVoucherFailedResponse !== null &&
        this.props.genCustomerVoucherFailedResponse.status === 400) ||
      this.props.genCustomerVoucherFailedResponse === "Network error"
    ) {
      this.props.showHideLoader(false);
      return (
        <MDBAlert color="danger" className="text-center">
          Unable to issue voucher. Please try again later or contact system
          administrator.
        </MDBAlert>
      );
    }
    return <span></span>;
  }

  isBookingStatusChangeSuccess() {
    if (this.props.genCustomerVoucherSuccessResponse.status === 200) {
      return (
        <MDBAlert color="success" className="text-center">
          Voucher has been generated and issued to customer and the booking is
          cancelled.
        </MDBAlert>
      );
    }

    return <span></span>;
  }

  renderStatusChangeConfirmation() {
    if (this.state.statusChangeConfirmation.length > 0) {
      return (
        <MDBCard border="info" className="m-3">
          <MDBCardBody className="text-info">
            <MDBCardTitle tag="h5">Confirm change status</MDBCardTitle>
            <MDBCardText>
              Status change to <strong>{this.state.status}</strong>.
              <br />
              <br />
              {this.state.statusChangeConfirmation}
            </MDBCardText>
            {this.isBookingStatusChangeSuccess()}
            {this.isBookingStatusChangeFailed()}
            {this.validateStatusChangeButton()}
          </MDBCardBody>
        </MDBCard>
      );
    }
    return <span></span>;
  }

  renderDiscountSection(coupon) {
    if (coupon.length > 0) {
      return <span></span>;
    } else {
      return (
        <MDBCol size="12">
          <MDBCol size="6" className="mt-4">
            <label htmlFor="idCoupon" className="grey-text">
              Discount Code
            </label>
            <input
              value={coupon}
              name="coupon"
              onChange={this.onCouponChange}
              type="text"
              id="idCoupon"
              className="form-control"
            />
            {this.isInvalidCoupon()}
          </MDBCol>
          <MDBCol size="2" className="mt-4">
            <MDBInput
              label="Discount"
              disabled
              value={this.state.discountAmount}
            />
          </MDBCol>
        </MDBCol>
      );
    }
  }

  renderBookingStatuses() {
    if (this.props.getStatusesSuccessResponse.status === 200) {
      let statuses = _.chain(
        `this.props.getStatusesSuccessResponse.data.statuses`
      )
        .orderBy(["name"], ["asc"])
        .value();

      return (
        <MDBCol md="6" className="mb-3">
          <label className="grey-text">Status</label>

          <select
            className="browser-default custom-select"
            name="status"
            onChange={this.statusChangeHandler}
            defaultValue={this.state.status}
          >
            {statuses.map((status) => (
              <option key={status.id} value={status.name}>
                {status.name}
              </option>
            ))}
          </select>

          <div className="mt-3">
            <label className="grey-text">Description</label>
            <h5>{this.state.statusDesc}</h5>
          </div>
        </MDBCol>
      );
    }
    return <span></span>;
  }

  showCalendarSelect = (show) => {
    this.setState({ showCalendarSelect: show });
  };

  doCharge(doCharge) {
    let bookingParams = {
      isUpdate: true,
      generateVoucher: false,
      doCharge: doCharge,
    };
    this.doBooking(bookingParams);
  }

  validatePriceChangeWarning() {
    const {
      origPrice,
      totalPrice,
      showPriceChangeWarning,
      couponDiscount,
      paid,
      isDefaultUser,
    } = this.state;

    if (
      couponDiscount === 0 &&
      showPriceChangeWarning &&
      origPrice < totalPrice &&
      !isDefaultUser
    ) {
      return (
        <MDBRow>
          <MDBCol size="12" className="mt-2 text-info price-change-msg">
            *** Price changed. Do you wish to send a{" "}
            <strong>payment request</strong> to the customer's email with the
            amount of{" "}
            <strong style={{ fontSize: "large" }}>
              ${Math.abs(origPrice - totalPrice)}?
            </strong>
            <MDBBtn
              color="primary"
              type="button"
              size="sm"
              onClick={() => this.doCharge(true)}
            >
              Send payment request
            </MDBBtn>
            <MDBBtn
              color="primary"
              type="button"
              size="sm"
              onClick={() => this.doCharge(false)}
            >
              Paid
            </MDBBtn>
          </MDBCol>
        </MDBRow>
      );
    } else if (showPriceChangeWarning && origPrice > totalPrice && paid) {
      return (
        <MDBRow>
          <MDBCol size="12" className="mt-2 text-info price-change-msg">
            *** Price changed. Upon saving, a <strong>credit voucher</strong>{" "}
            will be issued to the customer with the amout of{" "}
            <strong style={{ fontSize: "large" }}>
              ${Math.abs(origPrice - totalPrice)}
            </strong>
            . An email will be sent to the customer containing the voucher code
            ***
          </MDBCol>
        </MDBRow>
      );
    }

    return <span></span>;
  }

  renderMaxDurationExceedAcknowledge() {
    const { showExceedMaxDurationAcknowledge, maxDuration } = this.state;

    if (showExceedMaxDurationAcknowledge) {
      return (
        <MDBRow>
          <MDBCol>
            <div
              className="custom-control custom-checkbox mt-2"
              style={{ textAlign: "center" }}
            >
              <input
                type="checkbox"
                className="custom-control-input"
                id="checkMoreThanMaxDuration"
                defaultChecked={true}
                // onChange={this.checkMoreThanMaxDurationOnChange}
                required
              />
              <label
                className="custom-control-label"
                htmlFor="checkMoreThanMaxDuration"
              >
                I acknowledge that the customer will book more than the maximum
                duration{" "}
                <strong>
                  {maxDuration + " Minutes or " + maxDuration / 60 + " Hour/s"}
                </strong>
              </label>
            </div>
          </MDBCol>
        </MDBRow>
      );
    }
    return <span></span>;
  }

  toggleDetailsModal = () => {
    this.setState({
      showBookingDetailsModal: !this.state.showBookingDetailsModal,
    });
    this.resetBookingStates();
  };

  renderBookingDetailsForm() {
    const { showBookingDetailsModal, selectedBookingDetails } = this.state;

    if (this.props.isCloseBooking) {
      this.setState({
        selectedBookingDetails: {},
        showBookingDetailsModal: false,
      });
    }

    if (
      selectedBookingDetails != null &&
      typeof selectedBookingDetails.is_booked !== "undefined" &&
      showBookingDetailsModal
    ) {
      let locationList = _.isEmpty(this.props.getLocationMenuSuccessResponse)
        ? this.props.locations.results
        : this.props.getLocationMenuSuccessResponse.data.locations.results;

      let locationObj = _.filter(locationList, function (data) {
        return data.uuid == selectedBookingDetails.location.uuid;
      })[0];
      // let params = queryString.parse(this.props.location.search);

      return (
        <div className="booking-modal">
          <BookingEditor
            doCalculate={true}
            statuses={this.props.getStatusesSuccessResponse.data.statuses}
            selectedBooking={selectedBookingDetails}
            isView={
              !(
                validateAccess(
                  this.props.storeUserAccess,
                  "AdminBooking",
                  "updateBooking"
                ) && selectedBookingDetails.is_cancelled !== 1
              )
            }
            locationResource={this.state.locationResource}
            locationObj={locationObj}
          />
        </div>
      );
    }
    return <span></span>;
  }

  renderAvailableSlot(availableSlot, durationDefaultVal) {
    return (
      <MDBCol md="6">
        <label className="grey-text required">Select duration</label>
        <select
          className="browser-default custom-select"
          onChange={this.onDurationChange}
          defaultValue={durationDefaultVal}
          value={this.state.duration}
        >
          {availableSlot.map((time) => (
            <option key={time} value={time}>
              {time + " Minutes or " + time / 60 + " Hour/s"}
            </option>
          ))}
        </select>
      </MDBCol>
    );
  }

  toolbarItemRender() {
    return (
      <div className="informer">
        {this.maxBookingParticipants > 0 ? (
          <i>
            {" "}
            <small>
              (Max booking Participants is {this.maxBookingParticipants})
            </small>
          </i>
        ) : (
          ""
        )}
      </div>
    );
  }

  getBookingWarnings(chunks) {
    const { searchDateVal, recurrings } = this.state;

    var resourceId = 0;
    if (this.state.showBookingDetailsModal) {
      resourceId = this.state.selectedBookingDetails.resource.id;
    } else {
      resourceId = this.state.selectedBooking.resourceId;
    }
    var warnings = [];
    if (this.state.private) {
      chunks.forEach((value, index) => {
        var genStartTime = value.time;

        let currentDateTime = moment(searchDateVal + " " + genStartTime).format(
          "YYYY-MM-DD HH:mm"
        );

        let timezone = this.getTzDetails().timezone;
        let recurring = _.filter(recurrings, function (data) {
          let booking_from = moment(data.booking_from)
            .tz(timezone)
            .format("YYYY-MM-DD HH:mm");
          let booking_to = moment(data.booking_to)
            .tz(timezone)
            .format("YYYY-MM-DD HH:mm");
          return (
            data["resource_id"] == resourceId &&
            currentDateTime >= booking_from &&
            currentDateTime < booking_to
          );
        });

        if (recurring.length > 0) {
          warnings.push(
            "There is a recurring booking for the timeslot " + genStartTime
          );
        }

        let currentDate = moment().format("YYYY-MM-DD");
        let currentTime = moment().format("HH:mm");
        if (currentTime > genStartTime && searchDateVal <= currentDate) {
          warnings.push(
            "Selected timeslot " + genStartTime + " has been passed."
          );
        }
      });
    }

    return warnings;
  }

  confirmBooking = (warnings, conflicts, canBook) => {
    let selectedTime = this.state.time;
    let day = moment(this.props.selectedDate).format("YYYY-MM-DD");
    let from = _.split(selectedTime, "-")[0];
    let to = _.split(selectedTime, "-")[1];

    const modal = {
      isOpen: true,
      content: (
        <div>
          <p>
            Are you sure you want to book date {day} with timeslot from {from}{" "}
            to {to}?
          </p>
          {warnings.length > 0 ? (
            <span style={{ color: "red" }}>
              Please review the warnings below:
            </span>
          ) : (
            ""
          )}

          <ul>
            {warnings.map((warning, index) => (
              <li key={index} style={{ color: "red" }}>
                {warning}
              </li>
            ))}
          </ul>
          {conflicts.length > 0 ? (
            <span style={{ color: "red" }}>
              Booking cannot be created.
              {canBook && conflicts.length > 0
                ? " Please review the validation messages below:"
                : " Please review the conflicts below:"}
            </span>
          ) : (
            ""
          )}
          <ul>
            {conflicts.map((warning, index) => (
              <li
                key={index}
                style={{ color: "red" }}
                dangerouslySetInnerHTML={{ __html: warning }}
              ></li>
            ))}
          </ul>
        </div>
      ),
      title: <span style={{ color: "red" }}>Booking Warnings</span>,
      negativeButtonText: "Cancel",
      positiveButtonText:
        canBook && conflicts.length > 0
          ? "Yes, override validation errors."
          : "Yes, please proceed.",
      positiveButtonColor: "danger",
      negativeButtonAction: this.closeModal.bind(this),
      positiveButtonAction: this.submitBooking.bind(this),
    };

    if (!canBook) {
      modal["hasPositiveButtonAction"] = false;
      delete modal["positiveButtonAction"];
      delete modal["positiveButtonColor"];
      delete modal["positiveButtonText"];
    }
    this.props.toggleModal(modal);
  };

  checkBookingConflicts = (bookingParams = {}) => {
    const {
      first_name,
      last_name,
      email,
      mobile,
      address,
      invoice,
      paid,
      notes,
      selectedBooking,
      duration,
      origTime,
      time,
      isRecurring,
      frequencyInWeeks,
      paymentMethod,

      totalPrice,
      chargeAmount,
      lessAmount,
      unPaidAmount,

      couponDiscount,
      coupon,
      bookingUuid,
      bookingId,

      statusNotes,
      status,

      locationId,
      locationUuid,
      locationName,

      resourceId,
      resourceUuid,
      resourceName,
      participants,
    } = this.state;
    this.props.showHideLoader(true);

    let updateSchedule = this.state.updateSchedule;
    let endDate = this.state.endDate;
    let location = this.state.locationObj;
    let overwriteUpdateSchedule = false;
    let priceData = {
      amount: totalPrice,
      currency: "AUD",
    };

    if (this.state.coupon.length > 0) {
      priceData["couponDiscount"] = couponDiscount;
      priceData["coupon"] = coupon;
    }

    if (chargeAmount > 0) {
      priceData["charge"] = chargeAmount;
      overwriteUpdateSchedule = true;
    }

    if (unPaidAmount > 0) {
      priceData["unpaid"] = unPaidAmount;
    }

    if (lessAmount > 0) {
      priceData["refund"] = lessAmount;
      overwriteUpdateSchedule = true;
    }

    if (endDate) {
      endDate = moment(endDate)
        .tz(this.getTzDetails().timezone)
        .format("YYYY-MM-DD");
    }

    if (origTime != time) {
      updateSchedule = true;
    }

    let participantsData = [];
    _.map(this.state.participants, (participant) => {
      if (
        participant["checked_in"] != undefined &&
        participant["checked_in_time"] != undefined &&
        participant["checked_in_time"] != ""
      ) {
        participant["checked_in_time"] =
          moment(participant["checked_in_time"])
            .utc()
            .format("YYYY-MM-DDTHH:mm:ss") + "Z";
      }
      participantsData.push(participant);
    });

    let details = {
      resourceData: {
        organisationId: location.organisation.id,
        bookingData: {
          from: this.validateSelectedDuration().from,
          to: this.validateSelectedDuration().to,

          isRecurring: isRecurring,
          frequencyInWeeks: isRecurring ? frequencyInWeeks : "",
          endDate: endDate,

          chunks: this.generateChunk(),
          isPaid: paid,
          invoice: invoice,
          paymentMethod: paymentMethod,
          notes: notes,
        },
      },
      priceData: priceData,
      customerData: {
        first_name: first_name,
        last_name: last_name,
        email: email,
        mobile: mobile,
        address: address,
      },
      participantsData: participantsData,
    };

    this.props.showHideLoader(true);

    this.setState({
      isUpdate: bookingParams.isUpdate,
    });

    if (bookingParams.isUpdate) {
      details.resourceData.bookingData["bookingId"] = bookingId;
      if (status.length > 0) {
        details.resourceData.bookingData["status"] = status;
      }
      details.resourceData.bookingData["statusNotes"] = statusNotes;

      details.resourceData["locationId"] = locationId;
      details.resourceData["resourceId"] = resourceId;
      details.resourceData["resourceName"] = resourceName;

      details.resourceData.bookingData["updateSchedule"] =
        updateSchedule === true ? updateSchedule : overwriteUpdateSchedule;

      details.resourceData.bookingData["generate_voucher"] =
        bookingParams.generateVoucher;

      if (
        chargeAmount > 0 &&
        bookingParams.doCharge !== undefined &&
        bookingParams.doCharge
      ) {
        details.resourceData.bookingData["isPaid"] = false;
      } else {
        if (
          (couponDiscount > 0 && couponDiscount === chargeAmount) ||
          (couponDiscount > 0 && couponDiscount === unPaidAmount)
        ) {
          details.resourceData.bookingData["isPaid"] = true;
        }
      }
    } else {
      details.resourceData["locationId"] = location.id;
      details.resourceData["resourceId"] = selectedBooking.resourceId;
      details.resourceData["resourceName"] = selectedBooking.court;
    }
    this.props.checkBookingConflicts(
      details,
      this.props.authUser.sessionToken,
      "calendar"
    );
  };

  submitBookingHandler = (recurringWarnings, validationMessages) => {
    let chunks = this.generateChunk();
    let warnings = this.getBookingWarnings(chunks);
    let canBook = recurringWarnings.length == 0;
    const { isDefaultUser } = this.state;
    if (
      recurringWarnings.length > 0 ||
      warnings.length > 0 ||
      validationMessages.length > 0
    ) {
      if (isDefaultUser) {
        this.props.showNotification(
          "error",
          "Sorry, Unable to book the selected slot. There might be a conflicts with other bookings. Please contact system administrator."
        );
        this.props.showHideLoader(false);
      } else {
        let conflicts = [];
        recurringWarnings.forEach((value, index) => {
          let booking_from = moment(value.booking_from).tz(
            this.state.locationTimezone
          );
          let booking_to = moment(value.booking_to).tz(
            this.state.locationTimezone
          );
          let booking_time =
            booking_from.format("HH:mm") + " - " + booking_to.format("HH:mm");
          conflicts.push(
            "Reference " +
              value.booking_reference +
              " - " +
              booking_from.format("YYYY/MM/DD") +
              " " +
              booking_time
          );
        });

        _.map(validationMessages, function (value) {
          conflicts.push(value);
        });

        this.props.showHideLoader(false);
        this.confirmBooking(warnings, conflicts, canBook);
      }
    } else {
      this.submitBooking();
    }
  };

  submitHandler = (event) => {
    event.preventDefault();
    // this.props.clearSuccessHandler();
    // this.props.clearFailedHandler();
    this.setState({
      wasValidated: "was-validated",
      isBookingSaving: true,
      // formCleared: false
    });

    if (
      event.target.checkValidity() &&
      (this.state.alert.text == "" || this.state.alert.clearAfter)
    ) {
      this.checkBookingConflicts();
    } else {
      document.querySelector(".modal.show").scrollTo(0, 0);
    }
  };

  submitBooking() {
    this.props.showHideLoader(true);
    // if (!this.state.invalidCoupon) {
    let bookingParams = { isUpdate: false, generateVoucher: false };
    this.doBooking(bookingParams);
    // }
  }

  closeModal() {
    this.setState({
      selectedBookingDetails: {},
      showBookingDetailsModal: false,
    });
  }

  doStatusChange = (action) => (e) => {
    this.generateVoucher = false;
    if (action === "issueVoucher") {
      this.generateVoucher = true;
    }
    // let bookingParams = { isUpdate: true, generateVoucher: generateVoucher };
    // this.doBooking(bookingParams);

    // this.setState({
    //   disableStatusButton: true,
    //   disableSaveButton: true,
    // });
  };

  validateSelectedDuration() {
    let selectedTime = this.state.time;
    let reservationDate = moment(this.props.selectedDate).format("YYYY-MM-DD");

    let tz = this.getTzDetails(new Date(reservationDate));
    let from =
      moment(reservationDate + "T" + _.split(selectedTime, "-")[0] + tz.offset)
        .utc()
        .format()
        .substring(0, 19) + "Z";

    let to =
      moment(reservationDate + "T" + _.split(selectedTime, "-")[1] + tz.offset)
        .utc()
        .format()
        .substring(0, 19) + "Z";

    return { from: from, to: to };
  }

  generateChunk() {
    let selectedTime = this.state.time;
    let day = moment(this.props.selectedDate).format("dddd");
    let from = _.split(selectedTime, "-")[0];
    let to = _.split(selectedTime, "-")[1];

    let addTime = from;
    let chunks = [];
    chunks.push({
      day: day,
      time: from,
    });
    to = moment(to, "HH:mm").subtract(30, "minutes").format("HH:mm");

    while (addTime !== to) {
      addTime = moment(addTime, "HH:mm").add(30, "minutes").format("HH:mm");

      chunks.push({
        day: day,
        time: addTime,
      });
    }

    return chunks;
  }

  doBooking(bookingParams) {
    const {
      first_name,
      last_name,
      email,
      mobile,
      address,
      invoice,
      paid,
      notes,
      selectedBooking,
      duration,
      origTime,
      time,
      isRecurring,
      frequencyInWeeks,
      paymentMethod,

      totalPrice,
      chargeAmount,
      lessAmount,
      unPaidAmount,

      couponDiscount,
      coupon,
      bookingUuid,
      bookingId,

      statusNotes,
      status,

      locationId,
      locationUuid,
      locationName,

      resourceId,
      resourceUuid,
      resourceName,
      overwriteFee,
      overwriteFeeAmount,
    } = this.state;
    let updateSchedule = this.state.updateSchedule;
    let endDate = this.state.endDate;
    let location = this.state.locationObj;
    let overwriteUpdateSchedule = false;
    let priceData = {
      amount: totalPrice,
      currency: "AUD",
    };

    if (this.state.coupon.length > 0) {
      priceData["couponDiscount"] = couponDiscount;
      priceData["coupon"] = coupon;
    }

    if (chargeAmount > 0) {
      priceData["charge"] = chargeAmount;
      overwriteUpdateSchedule = true;
    }

    if (unPaidAmount > 0) {
      priceData["unpaid"] = unPaidAmount;
    }

    if (lessAmount > 0) {
      priceData["refund"] = lessAmount;
      overwriteUpdateSchedule = true;
    }

    if (overwriteFee && overwriteFeeAmount.length > 0) {
      priceData["overwriteFee"] = overwriteFee;
      priceData["overwriteFeeAmount"] = parseFloat(overwriteFeeAmount);
    }

    if (endDate) {
      moment(endDate).utc().format("YYYY-MM-DD");
    }

    if (origTime != time) {
      updateSchedule = true;
    }

    let participantsData = [];
    _.map(this.state.participants, (participant) => {
      let pt = Object.assign({}, participant);

      if (
        pt !== undefined &&
        pt["checked_in"] !== undefined &&
        pt["checked_in"] &&
        pt["checked_in_time"] != ""
      ) {
        pt["checked_in_time"] =
          moment(pt["checked_in_time"]).utc().format("YYYY-MM-DDTHH:mm:ss") +
          "Z";
      }
      participantsData.push(pt);
    });

    let details = {
      resourceData: {
        organisationId: location.organisation.id,
        bookingData: {
          from: this.validateSelectedDuration().from,
          to: this.validateSelectedDuration().to,

          isRecurring: isRecurring,
          frequencyInWeeks: isRecurring ? frequencyInWeeks : "",
          endDate: endDate,

          chunks: this.generateChunk(),
          isPaid: paid,
          invoice: invoice,
          paymentMethod: paymentMethod,
          notes: notes,
        },
      },
      priceData: priceData,
      customerData: {
        first_name: first_name,
        last_name: last_name,
        email: email,
        mobile: mobile,
        address: address,
      },
      participantsData: participantsData,
    };

    this.props.showHideLoader(true);

    this.setState({
      isUpdate: bookingParams.isUpdate,
      disableSaveButton: true,
    });

    if (bookingParams.isUpdate) {
      details.resourceData.bookingData["bookingId"] = bookingId;
      if (status.length > 0) {
        details.resourceData.bookingData["status"] = status;
      }
      details.resourceData.bookingData["statusNotes"] = statusNotes;

      details.resourceData["locationId"] = locationId;
      details.resourceData["resourceId"] = resourceId;
      details.resourceData["resourceName"] = resourceName;

      details.resourceData.bookingData["updateSchedule"] =
        updateSchedule === true ? updateSchedule : overwriteUpdateSchedule;

      details.resourceData.bookingData["generate_voucher"] =
        bookingParams.generateVoucher;

      if (
        chargeAmount > 0 &&
        bookingParams.doCharge !== undefined &&
        bookingParams.doCharge
      ) {
        details.resourceData.bookingData["isPaid"] = false;
        let sessionToken = "";
        if (typeof this.props.authUser.sessionToken != "undefined") {
          sessionToken = this.props.authUser.sessionToken;
        }
        this.props.doBooking(details, sessionToken);
      } else {
        if (
          (couponDiscount > 0 && couponDiscount === chargeAmount) ||
          (couponDiscount > 0 && couponDiscount === unPaidAmount)
        ) {
          details.resourceData.bookingData["isPaid"] = true;
        }
        this.props.updateBooking(
          details,
          this.props.authUser.sessionToken,
          bookingUuid
        );
      }
    } else {
      details.resourceData["locationId"] = location.id;
      details.resourceData["resourceId"] = selectedBooking.resourceId;
      details.resourceData["resourceName"] = selectedBooking.court;
      if (this.state.isDefaultUser) {
        this.props.doBooking(details);
      } else {
        this.props.doBooking(details, this.props.authUser.sessionToken);
      }
    }
  }

  resetBookingModal() {
    this.resetBookingStates();
    this.closeModal();
    this.props.selectDate(new Date(this.state.origSearchDateVal));
    this.props.clearBookingSuccessResponse();
    this.props.clearBookingFailedResponse();
    this.props.clearBookingStatusSuccessResponse();
    this.props.clearBookingStatusFailedResponse();
    this.props.clearGenCustomerVoucherSuccessResponse();
    this.props.clearGenCustomerVoucherFailedResponse();

    if (this.intervalId == null) {
      this.startCalendarRefresh();
    }
    if (this.state.private) {
      this.props.showHideLoader(true);
      let params = queryString.parse(this.props.location.search);
      if (
        this.state.origSearchDateVal !== undefined &&
        this.state.origSearchDateVal !== ""
      ) {
        // this.props.getLocationResourcesPrivate(
        //   params.uuid,
        //   {
        //     is_active: 1,
        //     display_online: 1,
        //     date: this.state.origSearchDateVal,
        //   },
        //   this.props.authUser.sessionToken
        // );
      }
    }
  }

  changeHandler = (event) => {
    this.setState({ ...this.state, [event.target.name]: event.target.value });
    let { participants } = this.state;

    if (
      event.target.dataset.type != undefined &&
      event.target.dataset.type == "customer"
    ) {
      let participantIndex = _.findIndex(participants, function (o) {
        return o.id == -1;
      });
      let participant = {};
      if (participantIndex < 0) {
        participant = {
          id: -1,
          is_primary: true,
          first_name: "",
          last_name: "",
          email: "",
          mobile: "",
        };
      } else {
        participant = participants[participantIndex];
      }

      if (event.target.name == "email") {
        let result = _.find(participants, function (o) {
          return (
            o.email == event.target.value &&
            o.id != -1 &&
            event.target.value != ""
          );
        });
        this.resetAlertMessage();
        if (result != undefined) {
          alert = {
            title: "Please review the following error: ",
            text: [
              "Participant's email already added. Please enter an unique email",
            ],
            type: "danger",
          };
          this.setState({ alert });
          return;
        }
      }

      participant[event.target.name] = event.target.value;
      if (this.state.email.length > 0) {
        participant["email"] = this.state.email;
      }

      if (participantIndex < 0) {
        participants.unshift(participant);
      } else {
        participants[participantIndex] = participant;
      }

      this.setState({
        participants: participants,
      });
    }
  };

  onACheckChange = (evt) => {
    this.setState({ paid: !this.state.paid });
  };

  setDefaultStatus(status) {
    //-- TODO
    let statusAttr = _.chain(
      this.props.getStatusesSuccessResponse.data.statuses
    )
      .map((stat) => {
        if (stat.name === status) {
          return stat;
        }
        return [];
      })
      .filter(_.size)
      .value()[0];

    let statusDesc = statusAttr.additional_notes;

    this.setState({ status: status, statusDesc: statusDesc });
  }

  statusChangeHandler = (evt) => {
    let status = evt.target.value;
    let statusAttr = _.chain(
      this.props.getStatusesSuccessResponse.data.statuses
    )
      .map((stat) => {
        if (stat.name === status) {
          return stat;
        }
        return [];
      })
      .filter(_.size)
      .value()[0];

    let statusDesc = statusAttr.additional_notes;
    let statusChangeConfirmation = [];

    //-- TODO checking issue_voucher

    //-- Charge, issue voucher

    if (statusAttr.is_chargable === 1) {
      statusChangeConfirmation.push(
        <span key="st1">
          <strong>Charge:</strong> Customer will not be able to refund the
          booking fee and the booking will be cancelled.
          <br />
          <br />
        </span>
      );
    }
    if (statusAttr.is_overrideble === 1) {
      statusChangeConfirmation.push(
        <span key="st2">
          <strong>Issue Voucher:</strong> Credit Voucher with the amount of $
          {this.state.totalPrice} will be issued to customer and the booking
          will be cancelled.
          <br />
          <br />
        </span>
      );
    }
    if (statusAttr.issue_voucher === 1) {
      statusChangeConfirmation.push(
        <span key="st3">
          <strong>Issue Voucher:</strong> Credit Voucher with the amount of $
          {this.state.totalPrice} will be issued to customer and the booking
          will be cancelled.
          <br />
          <br />
        </span>
      );
    }

    // if (status === "Checked in") {
    //   statusDesc = "The Visitor/User arrived and used the resource";
    //   statusChangeConfirmation = "";
    // } else if (status === "Unavoidable Circumstances") {
    //   statusDesc = "Visitor/User Retains the booking fee for use another time";
    //   statusChangeConfirmation = `Do you wish to issue a Credit Voucher with amount of $${this.state.totalPrice} to this customer?
    //   Customer will receive an email containing the credit voucher.`;
    // } else if (status === "No Show") {
    //   statusDesc = "Visitor/User looses the booking Fee";
    //   statusChangeConfirmation = `Customer will not be able to refund the booking fee and the booking will be cancelled.
    //   Do you wish to continue changing the status?`;
    // } else if (status === "Cancellation") {
    //   statusDesc = "Visitor/User Retains the booking fee for use another time";
    //   statusChangeConfirmation = `Do you wish to issue a Credit Voucher with amount of $${this.state.totalPrice} to this customer?
    //   Customer will receive an email containing the credit voucher.`;
    // } else if (status === "Late Cancellation") {
    //   statusDesc = "Visitor/User looses the booking Fee";
    //   statusChangeConfirmation = `Customer will not be able to refund the booking fee and the booking will be cancelled.
    //   Do you wish to continue changing the status?`;
    // }

    this.setState({
      status: status,
      statusDesc: statusDesc,
      statusChangeConfirmation: statusChangeConfirmation,

      isChargable: statusAttr.is_chargable,
      issueVoucher: statusAttr.issue_voucher,
      isOverrideble: statusAttr.is_overrideble,
    });
  };

  onRecurringCheckChange = (evt) => {
    this.setState({
      isRecurring: !this.state.isRecurring,
      frequencyInWeeks: this.state.isRecurring === false ? "Weekly" : "",
      endDate: "",
    });
  };

  onOverwritePriceCheckChange = (evt) => {
    this.setState({
      overwriteFee: !this.state.overwriteFee,
    });
  };

  checkMoreThanMaxDurationOnChange = (evt) => {
    this.setState({
      checkMoreThanMaxDuration: !this.state.checkMoreThanMaxDuration,
    });
  };

  RecurringBookingOption() {
    let { endDate } = this.state;

    if (this.state.isRecurring) {
      let enddateAddDays =
        this.state.recurringFrequencies[this.state.frequencyInWeeks];

      return (
        <MDBCol md="6">
          <div>
            <label className="grey-text mt-4">Frequency in Weeks</label>
            <select
              className="browser-default custom-select"
              name="frequencyInWeeks"
              defaultValue={this.state.frequencyInWeeks}
              onChange={this.changeHandler}
            >
              <option value="Weekly">Weekly</option>
              <option value="Fortnightly">Fortnightly</option>
              <option value="Monthly">Monthly</option>
            </select>
          </div>
          <div>
            <label className="grey-text mt-4">End Date</label>
            <br></br>
            <DatePicker
              className="custom-input"
              placeholderText="Select End Date"
              selected={endDate}
              onChange={this.endDateChangeHandler}
              dateFormat="dd/MM/yyyy"
              name="endDate"
              filterDate={this.isWeekday}
              isClearable={true}
            />
          </div>
        </MDBCol>
      );
    }
    return <span></span>;
  }

  endDateChangeHandler = (date) => {
    this.setState({
      endDate: date,
    });
  };

  isWeekday = (date) => {
    let enddateAddDays =
      this.state.recurringFrequencies[this.state.frequencyInWeeks];
    if (this.state.isRecurring) {
      var selectedDate = this.props.selectedDate;
      var a = moment(selectedDate);
      var b = moment(date);

      if (a.format("YYYY-MM-DD") >= b.format("YYYY-MM-DD")) {
        return false;
      }

      if (
        this.cachePrevDate != "" &&
        typeof this.cachePrevDate !== "undefined"
      ) {
        selectedDate = this.cachePrevDate;
      }

      var a = moment(selectedDate);
      let daysDiff = a.diff(date, "days") - 1;
      let aDay = a.format("dddd");
      let bDay = b.format("dddd");
      return date >= a && daysDiff % enddateAddDays == 0;
    }
  };

  isInvalidCoupon() {
    if (this.state.couponErrorMsg.length > 0) {
      return (
        <span style={{ color: "red", fontWeight: "bold" }}>
          {this.state.couponErrorMsg}
        </span>
      );
    }
    return <span></span>;
  }
  onCouponChange = (evt) => {
    this.setState({
      coupon: evt.target.value,
      couponErrorMsg: "",
      invalidCoupon: false,
      couponDiscount: 0,
    });
  };

  calculatePrice() {
    const {
      updateSchedule,
      first_name,
      last_name,
      email,
      chargeAmount,
      unPaidAmount,
      participants,
      overwriteFee,
      overwriteFeeAmount,
    } = this.state;
    this.props.showHideLoader(true);
    let couponObj = {};
    if (this.state.coupon.length > 0) {
      couponObj["coupon"] = this.state.coupon;
    }

    if (chargeAmount > 0) {
      couponObj["charge"] = chargeAmount;
    }

    if (unPaidAmount > 0) {
      couponObj["unpaid"] = unPaidAmount;
    }

    if (overwriteFee && overwriteFeeAmount.length > 0) {
      couponObj["overwriteFee"] = overwriteFee;
      couponObj["overwriteFeeAmount"] = parseFloat(overwriteFeeAmount);
    }

    let location = this.state.locationObj;
    let locationName = "";
    let locationId = "";
    let resourceName = "";
    let resourceId = "";
    let bookingId = "";

    if (this.state.showBookingDetailsModal) {
      locationName = this.state.selectedBookingDetails.location.name;
      locationId = this.state.selectedBookingDetails.location.id;
      resourceName = this.state.selectedBookingDetails.resource.name;
      resourceId = this.state.selectedBookingDetails.resource.id;
      bookingId = this.state.selectedBookingDetails.id;
    } else {
      locationId = location.id;
      resourceId = this.state.selectedBooking.resourceId;
      resourceName = this.state.selectedBooking.court;
    }

    let participantsData = [];
    _.map(participants, (participant) => {
      let pt = Object.assign({}, participant);

      if (
        pt !== undefined &&
        pt["checked_in"] !== undefined &&
        pt["checked_in"] &&
        pt["checked_in_time"] != ""
      ) {
        pt["checked_in_time"] =
          moment(pt["checked_in_time"]).utc().format("YYYY-MM-DDTHH:mm:ss") +
          "Z";
      }
      participantsData.push(pt);
    });

    let details = {
      resourceData: {
        organisationId: location.organisation.id,
        locationId: locationId,
        resourceId: resourceId,
        resourceName: resourceName,
        bookingData: {
          updateSchedule: updateSchedule,
          from: this.validateSelectedDuration().from,
          to: this.validateSelectedDuration().to,
          chunks: this.generateChunk(),
        },
      },
      customerData: {
        first_name: first_name,
        last_name: last_name,
        email: email,
      },
      priceData: couponObj,
      participantsData: participantsData,
    };

    this.setState({
      locked: details,
    });

    if (bookingId > 0) {
      details.resourceData.bookingData["bookingId"] = bookingId;
    }
    if (websocketApi.isOpen) {
      websocketApi.send(JSON.stringify({ ...details, action: "lock" }));
    }

    if (this.state.private) {
      this.props.calculatePrice(details, this.props.authUser.sessionToken);
    } else {
      this.props.calculatePrice(details);
    }
  }

  getOriginalPrice(selectedBookingDetails) {
    let couponObj = {};
    let location = this.state.locationObj;
    let locationId = selectedBookingDetails.location.id;
    let resourceName = selectedBookingDetails.resource.name;
    let resourceId = selectedBookingDetails.resource.id;

    let details = {
      resourceData: {
        organisationId: location.organisation.id,
        locationId: locationId,
        resourceId: resourceId,
        resourceName: resourceName,
        bookingData: {
          from: this.validateSelectedDuration().from,
          to: this.validateSelectedDuration().to,
          chunks: this.generateChunk(),
        },
      },

      priceData: couponObj,
    };

    this.setState({ doneGettingOriginalPrice: false });
    if (this.state.private) {
      this.props.calculatePrice(details, this.props.authUser.sessionToken);
    } else {
      this.props.calculatePrice(details);
    }
  }

  debouncedCalculatePrice = _.debounce(function () {
    this.calculatePrice();
  }, 10);

  getCustomerResult(prevProps, prevState) {
    if (prevProps.customerResponse !== this.props.customerResponse) {
      this.props.showHideLoader(false);
      let resultContainer = [];
      if (this.props.customerResponse.data !== undefined) {
        resultContainer = _.chain(this.props.customerResponse.data.results)
          .orderBy(["first_name"], ["asc"])
          .value();
      }
      this.setState({
        customerResultContainer: resultContainer,
      });
    }
  }

  debouncedSearchCustomer = _.debounce(function (val) {
    let params = { limit: 10, query: val };
    const { isDefaultUser, locationObj } = this.state;
    if (isDefaultUser) {
      params["organisationId"] = locationObj.organisation.id;
    }
    this.props.getCustomers(params, this.props.authUser.sessionToken);
  }, 10);

  renderCustomerAutoComplete() {
    const { isLocationPerMembership } = this.state;
    let { participants } = this.state;
    return (
      <div className="autoComplete">
        <label htmlFor="states-autocomplete">Search customer</label>
        <Autocomplete
          autoComplete="off"
          inputProps={{ id: "states-autocomplete" }}
          wrapperStyle={{ width: "100%", display: "inline-block" }}
          menuStyle={{ position: "absolute", background: "red", zIndex: "3" }}
          value={this.state.value}
          items={this.state.customerResultContainer}
          getItemValue={(item) => {
            let label =
              item.first_name + " " + item.last_name + ", " + item.email;
            if (item.membership) {
              label +=
                " - " +
                (item.membership.number ? item.membership.number : "N/A") +
                " - " +
                item.membership.name +
                " " +
                item.membership.type.name;
            }
            return label;
          }}
          onSelect={(value, item) => {
            let result = _.find(participants, function (o) {
              return o.email == item.email && o.id != -1 && item.email != "";
            });
            this.resetAlertMessage();

            let participant = null;

            if (result != undefined) {
              alert = {
                title: "Please review the following error: ",
                text: [
                  "Participant's email already added. Please enter an unique email",
                ],
                type: "danger",
              };
              this.setState({ alert });
            } else {
              participant = {
                first_name: item.first_name,
                last_name: item.last_name,
                email: item.email,
                mobile: item.mobile,
                address: item.address,
                is_primary: true,
                id: -1,
              };
            }
            if (participant) {
              let participantIndex = _.findIndex(participants, function (o) {
                return o.id == -1;
              });
              if (participantIndex >= 0) {
                participants[participantIndex] = participant;
              } else {
                participants.unshift(participant);
              }
            }

            this.setState({
              customerId: item.id,
              value,
              customerResultContainer: [item],
              first_name: item.first_name,
              last_name: item.last_name,
              email: item.email,
              mobile: item.mobile,
              address: item.address,
              participants: participants,
              triggerPricing: true,
            });

            if (isLocationPerMembership) {
              this.props.showHideLoader(true);
            }
          }}
          onChange={(event, value) => {
            clearTimeout(this.state.timer);
            let timer = setTimeout(() => {
              this.debouncedSearchCustomer(value);
            }, 500);
            this.setState({
              ...this.state,
              timer: timer,
              value,
              customerId: "",
            });
          }}
          renderMenu={(children) => <div className="menu">{children}</div>}
          renderItem={(item, isHighlighted) => (
            <div
              className={`item ${isHighlighted ? "item-highlighted" : ""}`}
              key={item.id}
            >
              {item.first_name + " " + item.last_name + ", " + item.email}
              {item.membership
                ? " - " +
                  (item.membership.number ? item.membership.number : "N/A") +
                  " - " +
                  item.membership.name +
                  " " +
                  item.membership.type.name
                : ""}
            </div>
          )}
        />
      </div>
    );
  }

  renderParticipantAutoComplete() {
    const { isLocationPerMembership } = this.state;
    return (
      <div className="autoComplete">
        <label htmlFor="participant-autocomplete">Search Participant</label>
        <Autocomplete
          autoComplete="off"
          inputProps={{ id: "participant-autocomplete" }}
          wrapperStyle={{ width: "100%", display: "inline-block" }}
          menuStyle={{ position: "absolute", background: "red", zIndex: "3" }}
          items={this.state.customerResultContainer}
          value={this.state.participantValue}
          getItemValue={() => ""}
          onSelect={(participantValue, item) => {
            let result = _.find(this.state.participants, function (o) {
              return o.email == item.email;
            });
            this.resetAlertMessage();
            if (result != undefined) {
              alert = {
                title: "Please review the following error: ",
                text: [
                  "Participant's email already added. Please enter an unique email",
                ],
                type: "danger",
                clearAfter: true,
              };
              this.setState({ alert });
              document.querySelector(".modal.show").scrollTo(0, 0);
              return;
            }

            let participantIndex = _.findIndex(
              this.state.participants,
              function (o) {
                return o.email == item.email;
              }
            );

            let participant = {
              id: item.id,
              first_name: item.first_name,
              last_name: item.last_name,
              email: item.email,
              mobile: item.mobile,
              address: item.address,
            };

            if (participantIndex < 0) {
              this.state.participants.push(participant);
            } else {
              this.state.participants[participantIndex] = participant;
            }

            this.setState({
              participantValue,
            });

            if (isLocationPerMembership) {
              this.calculatePrice();
            }
          }}
          onChange={(event, participantValue) => {
            clearTimeout(this.state.timer);
            let timer = setTimeout(() => {
              this.debouncedSearchCustomer(participantValue);
            }, 500);
            this.setState({
              ...this.state,
              participantValue,
              timer: timer,
            });
          }}
          renderMenu={(children) => <div className="menu">{children}</div>}
          renderItem={(item, isHighlighted) => (
            <div
              className={`item ${isHighlighted ? "item-highlighted" : ""}`}
              key={item.id}
            >
              {item.first_name + " " + item.last_name + ", " + item.email}
              {item.membership
                ? " - " +
                  (item.membership.number ? item.membership.number : "N/A") +
                  " - " +
                  item.membership.name +
                  " " +
                  item.membership.type.name
                : ""}
            </div>
          )}
        />
      </div>
    );
  }

  toggle = () => {
    this.setState({
      showBookingModal: !this.state.showBookingModal,
    });
    this.resetBookingStates();
  };

  resetAlertMessage() {
    alert = {
      title: "",
      text: "",
      type: "",
      clearAfter: false,
    };
    this.setState({ alert });
  }

  showAlert() {
    if (this.state.alert.text !== "") {
      return (
        <MDBAlert color={`${this.state.alert.type}`}>
          <strong>{this.state.alert.title}</strong>
          <br />
          <ul className="text-left">
            {this.state.alert.text.map((text, index) => (
              <li key={index}>{text}</li>
            ))}
          </ul>
        </MDBAlert>
      );
    }
  }

  allowUpdatingParticipant(e) {
    if (
      (typeof e.row.data != "undefined" &&
        typeof e.row.data.is_primary != "undefined") ||
      e.row.data.is_primary
    ) {
      let editableFields = ["checked_in_time"];
      e.row.cells.forEach((column, index) => {
        e.row.cells[index].column.isEditable = editableFields.includes(
          column.column.dataField
        );
      });
    }
    return true;
  }

  allowDeletingParticipant(e) {
    return (
      typeof e.row.data.is_primary == "undefined" || !e.row.data.is_primary
    );
  }

  renderBookingParticipants() {
    const { isDefaultUser } = this.state;
    let columns = [
      {
        fieldName: "first_name",
        displayName: "First Name",
        isEditable: true,
        dataType: "",
        isRequired: true,
      },
      {
        fieldName: "last_name",
        displayName: "Last Name",
        isEditable: true,
        dataType: "",
        isRequired: true,
      },
      {
        fieldName: "mobile",
        displayName: "Mobile",
        isEditable: true,
        dataType: "text",
        isRequired: true,
        pattern: "^[0-9]{10,15}$",
        patternErrorMessage: "Please enter a valid contact number",
      },
      {
        fieldName: "email",
        displayName: "Email",
        isEditable: true,
        dataType: "email",
        isRequired: true,
        validationCallback: this.participantUniqueValidation,
        validationCallbackMessage:
          "Participant's email already added. Please enter an unique email.",
      },
    ];

    if (!isDefaultUser) {
      columns.push(
        {
          fieldName: "checked_in",
          displayName: "Checked In",
          isEditable: true,
          sourceName: "value",
          sourceId: "id",
          sources: [
            {
              id: 0,
              value: "No",
            },
            {
              id: 1,
              value: "Yes",
            },
          ],
        },
        {
          fieldName: "checked_in_time",
          displayName: "Checked In Timestamp",
          isEditable: false,
        }
      );
    }

    let rows = _.uniqWith(Object.values(this.state.participants), _.isEqual);
    let canAdd =
      rows.length < this.maxBookingParticipants ||
      this.maxBookingParticipants == -1;
    return (
      <CustomDataGrid
        key={this.state.showBookingModal}
        source={rows}
        columns={columns}
        rowValidating={this.rowValidating}
        allowDeleting={this.allowDeletingParticipant}
        allowUpdating={this.allowUpdatingParticipant}
        canAdd={canAdd}
        key="id"
        actions={["edit", "delete"]}
        editMode={"form"}
        confirmDeleteMessage={""}
        triggerUpdatedEvent={this.triggerEvent}
        triggerInsertedEvent={this.triggerInsertEvent}
        triggerDeletedEvent={this.triggerDeletedEvent}
        toolbarItemRender={this.toolbarItemRender}
      />
    );
  }

  resetBookingStates() {
    this.startCalendarRefresh();

    this.setState({
      isParticipantLoaded: false,
      isBookingSaving: false,
      isConflictLoaded: false,
      customerId: "",
      first_name: "",
      last_name: "",
      email: "",
      mobile: "",
      address: "",
      invoice: "",
      paid: false,
      notes: "",
      selectedBooking: {},
      duration: "",
      origTime: "",
      time: "",
      paymentMethod: "Credit Card",
      isRecurring: false,
      frequencyInWeeks: "Weekly",
      totalPrice: 0,
      origPrice: 0,
      doneGettingOriginalPrice: false,
      showPriceChangeWarning: false,
      chargeAmount: 0,
      unPaidAmount: 0,
      lessAmount: 0,
      totalAmount: 0,
      unPaidAmount: 0,

      wasValidated: "",
      isInitialPriceComputed: false,
      showBookingModal: false,

      isClientSideFilter: false,
      locationResourcesLoaded: false,

      coupon: "",
      couponErrorMsg: "",
      invalidCoupon: false,
      couponDiscount: 0,

      showBookingDetailsModal: false,
      selectedBookingDetails: {},

      durationDefaultVal: 30,

      discountAmount: 0,
      receiptUrl: "",
      vendor: "",

      bookingRef: "",
      bookingUuid: "",
      bookingId: "",

      locationId: "",
      locationUuid: "",
      locationName: "",

      resourceId: "",
      resourceUuid: "",
      resourceName: "",

      customerId: "",
      customerUuid: "",

      origStatus: "",
      status: "",
      statusDesc: "",
      statusChangeConfirmation: "",

      statusNotes: "",

      isUpdate: true,

      activeItemInnerPills: "1",

      isChargable: 0,
      issueVoucher: 0,
      isOverrideble: 0,

      paymentTransaction: {},

      paymentHistoryElem: [],
      bookingStatusHistoryElem: [],

      disableStatusButton: false,

      generateVoucher: false,

      disableSaveButton: false,
      showRecurringWarning: false,
      searchDateVal: this.state.origSearchDateVal,

      showCalendarSelect: false,
      updateSchedule: false,

      showExceedMaxDurationAcknowledge: false,
      maxDuration: 0,
      maxDurationInText: "",
      checkMoreThanMaxDuration: false,

      value: "",
      participants: [],
      readOnlyEmail: false,
      defaultCustomer: {},
      overwriteFee: false,
      overwriteFeeAmount: "",
    });

    this.generateVoucher = false;
  }

  validateShowExceedMaxDuration(duration, resourceUuid, isBookingDetails) {
    const { locationResourcesContainer, selectedBooking } = this.state;

    let maxDuration = 0;

    if (isBookingDetails) {
      let resource = _.chain(locationResourcesContainer.results)
        .map((resource) => {
          if (resource.uuid === resourceUuid) {
            return resource;
          }
          return [];
        })
        .filter(_.size)
        .value()[0];

      maxDuration = new Number(
        _.replace(resource.attributes.max_duration, "m", "")
      ).valueOf();
    } else {
      maxDuration = new Number(
        _.replace(selectedBooking.maxDuration, "m", "")
      ).valueOf();
    }

    let showExceedMaxDurationAcknowledge = false;
    if (new Number(duration).valueOf() > maxDuration) {
      showExceedMaxDurationAcknowledge = true;
    }

    this.setState({
      maxDuration: maxDuration,
      showExceedMaxDurationAcknowledge: showExceedMaxDurationAcknowledge,
    });
  }

  openBookingDetailsModal = (paramData, booked) => {
    clearInterval(this.intervalId);
    this.intervalId = null;
    let getAvailableSlot = this.getAvailableSlotPrivate(
      paramData.resourceUuid,
      paramData.time
    );

    let bookObj = booked[0];

    let startTime = moment(bookObj.start_time)
      .tz(this.getTzDetails().timezone)
      .format("HH:mm");
    let endTime = moment(bookObj.end_time)
      .tz(this.getTzDetails().timezone)
      .format("HH:mm");

    let t1 = moment(bookObj.start_time);
    let t2 = moment(bookObj.end_time);

    let duration = t2.diff(t1, "minutes");

    let paymentHistoryElem = []; //this.buildPaymentHistory(bookObj.transaction);

    this.setState({
      selectedBookingDetails: booked[0],
    });

    // this.getOriginalPrice(booked[0]);
    this.setState({
      // origPrice: bookObj.transaction.totalAmount,
      showBookingDetailsModal: true,
      selectedBookingDetails: booked[0],

      customerId: bookObj.customer.id,
      first_name: bookObj.customer.first_name,
      last_name: bookObj.customer.last_name,
      email: bookObj.customer.email,
      mobile: bookObj.customer.mobile,
      address: bookObj.customer.address,

      invoice: bookObj.transaction.invoice,
      paid: bookObj.transaction.ispaid ? true : false,
      notes: bookObj.comments,
      time: startTime + "-" + endTime,
      origTime: startTime + "-" + endTime,
      // paymentMethod: bookObj.payment.paymentMethod,
      // coupon: bookObj.payment.discountCode,

      durationDefaultVal: duration,
      duration: duration,

      // totalPrice: bookObj.transaction.totalAmount,
      discountAmount: bookObj.transaction.totalVoucherCreditAmount,
      // receiptUrl: bookObj.payment.receipt,
      // vendor: bookObj.payment.vendor,

      bookingRef: bookObj.booking_reference,
      bookingUuid: bookObj.uuid,
      bookingId: bookObj.id,

      locationId: bookObj.location.id,
      locationUuid: bookObj.location.uuid,
      locationName: bookObj.location.name,

      resourceId: paramData.resourceId,
      resourceUuid: bookObj.resource.uuid,
      resourceName: bookObj.resource.name,

      customerId: bookObj.customer.id,
      customerUuid: bookObj.customer.uuid,

      origStatus: bookObj.status,
      status: bookObj.status,
      // statusDesc: "",
      // statusChangeConfirmation: "",

      // statusNotes: "",
      getAvailableSlot: getAvailableSlot,

      paymentTransaction: bookObj.transaction,

      isRecurring: bookObj.is_recurring === 1 ? true : false,
      frequencyInWeeks: bookObj.recurring_type,

      paymentHistoryElem: paymentHistoryElem,

      showRecurringWarning: bookObj.is_recurring === 1 ? true : false,

      origSearchDateVal: _.cloneDeep(this.state.searchDateVal),
    });

    //this.validateShowExceedMaxDuration(duration, bookObj.resource.uuid, true);

    //this.setDefaultStatus(bookObj.status);

    //this.props.getBookingStatus(bookObj.uuid, this.props.authUser.sessionToken);
  };

  toggleBookingModal = (showBookingModal) => {
    this.resetAlertMessage();
    this.setState({
      value: null,
      participants: [],
      showBookingModal: showBookingModal,
      customerId: "",
      participants: [],
      first_name: "",
      last_name: "",
      email: "",
      mobile: "",
      address: "",
      invoice: "",
      paid: false,
      notes: "",
      selectedBooking: {},
      duration: "",
      origTime: "",
      time: "",
      paymentMethod: "Credit Card",
      isRecurring: false,
      frequencyInWeeks: "Weekly",
      totalPrice: 0,
      origPrice: 0,
      doneGettingOriginalPrice: false,
      showPriceChangeWarning: false,
      chargeAmount: 0,
      unPaidAmount: 0,
      lessAmount: 0,
      totalAmount: 0,
      unPaidAmount: 0,

      wasValidated: "",
      coupon: "",
      statusNotes: "",
      isChargable: 0,
      issueVoucher: 0,
      isOverrideble: 0,
      // customerResultContainer: [],
      value: "",
    });
    const { locked } = this.state;
    if (websocketApi.isOpen) {
      websocketApi.send(JSON.stringify({ ...locked, action: "release_lock" }));
    }
    //this.resetBookingModal();
  };

  openBookingModal = (paramData) => {
    const { isChangeSchedule, locationResourcesContainer } = this.state;
    clearInterval(this.intervalId);
    let resource = _.chain(locationResourcesContainer.results)
      .map((resource) => {
        if (resource.uuid === paramData.resourceUuid) {
          return resource;
        }
        return [];
      })
      .filter(_.size)
      .value()[0];

    if (
      typeof resource.attributes.max_participants !== "undefined" &&
      resource.attributes.max_participants != ""
    ) {
      this.maxBookingParticipants = resource.attributes.max_participants;
    }

    if (isChangeSchedule) {
      this.props.bookingChangeSchedule({
        time: paramData.time,
        origTime: paramData.time,
        defaultEndTime: paramData.defaultEndTime,
        defaultStartTime: paramData.defaultStartTime,
        useCalendarSelectedTime: true,
        resourceName: paramData.court,
        resourceUuid: paramData.resourceUuid,
        resourceId: paramData.resourceId,
        updateSchedule: true,
        isRecurring: false,
        searchDateVal: this.state.searchDateVal,
        locationResource: resource,
      });
      this.setState({
        showCalendarSelect: false,
      });
    } else if (this.state.showBookingDetailsModal) {
      let getAvailableSlot = this.getAvailableSlotPrivate(
        paramData.resourceUuid,
        paramData.time
      );

      let start = paramData.time.split("-")[0];
      let duration = this.state.durationDefaultVal;
      let defaultEndTime = paramData.defaultEndTime;

      let end = start;
      let endMeet = false;

      let actualDuration = 0;

      let bookedStartTimeArr = _.chain(paramData.bookings)
        .map((book) => {
          return {
            startTime: moment(book.start_time)
              .tz(this.getTzDetails().timezone)
              .format("HH:mm"),
            endTime: moment(book.end_time)
              .tz(this.getTzDetails().timezone)
              .format("HH:mm"),
            bookingRef: book.booking_reference,
          };
        })
        .orderBy(["startTime"], ["asc"])
        .value();

      while (!endMeet) {
        end = moment(end, "HH:mm").add(30, "minutes").format("HH:mm");
        actualDuration += 30;

        _.map(bookedStartTimeArr, (bookTimeObj) => {
          if (
            this.state.bookingRef !== bookTimeObj.bookingRef &&
            bookTimeObj.startTime === end
          ) {
            endMeet = true;
          }
        });

        if (moment(end, "HH:mm").isSame(moment(defaultEndTime, "HH:mm"))) {
          endMeet = true;
        }
        if (actualDuration === duration) {
          endMeet = true;
        }
      }

      let time = `${start}-${end}`;

      this.setState({
        time: time,
        origTime: time,
        getAvailableSlot: getAvailableSlot,
        showCalendarSelect: false,

        resourceName: paramData.court,
        resourceUuid: paramData.resourceUuid,
        resourceId: paramData.resourceId,
        updateSchedule: true,
        isRecurring: false,
        isUpdate: true,
        duration:
          this.state.durationDefaultVal < actualDuration
            ? this.state.durationDefaultVal
            : actualDuration,
      });
    } else {
      let getAvailableSlot = [];
      if (
        validateAccess(
          this.props.storeUserAccess,
          "BookingDetails",
          "allowBeyondMaxDuration"
        )
      ) {
        getAvailableSlot = this.getAvailableSlotPrivate(
          paramData.resourceUuid,
          paramData.time
        );
      } else {
        getAvailableSlot = this.getAvailableSlot(
          paramData.resourceUuid,
          paramData.time
        );
        this.setDefaultCustomer();

        let minDuration = new Number(_.replace(paramData.minDuration, "m", ""));

        let timeFrom = _.split(paramData.time, "-")[0];
        let timeTo = moment(_.split(paramData.time, "-")[0], "HH:mm")
          .add(minDuration, "minutes")
          .format("HH:mm");

        paramData.time = timeFrom + "-" + timeTo;
      }

      this.setState({
        isUpdate: true,
        showBookingModal: true,
        selectedBooking: paramData,
        origTime: paramData.time,
        time: paramData.time,
        isInitialPriceComputed: false,
        getAvailableSlot: getAvailableSlot,
        resourceId: paramData.resourceId,
        origSearchDateVal: _.cloneDeep(this.state.searchDateVal),
      });
    }
  };

  setDefaultCustomer() {
    if (this.state.isDefaultUser) {
      const { customerResultContainer, locationObj } = this.state;
      let customer = _.filter(customerResultContainer, function (data) {
        return data.organisation.uuid == locationObj.organisation.uuid;
      })[0];
      if (customer !== undefined) {
        let participant = {
          id: -1,
          first_name: customer.first_name,
          last_name: customer.last_name,
          email: customer.email,
          mobile: customer.mobile,
          address: customer.address,
          is_primary: true,
        };

        this.state.participants.push(participant);

        this.setState({
          first_name: customer.first_name,
          last_name: customer.last_name,
          email: customer.email,
          mobile: customer.mobile,
          address: customer.address,
          readOnlyEmail: customer.email.length > 0,
          defaultCustomer: customer,
        });
      } else {
        this.setState({
          email: this.props.authUser.username,
          readOnlyEmail: true,
        });
      }
    }
  }

  debouncedCheckout = _.debounce(function () {
    this.props.history.push("/checkout");
  }, 10);

  shouldComponentUpdate(nextProps, nextState) {
    if (nextProps.isChangeSchedule) {
      if (nextProps.showCalendarSelect) {
        return true;
      } else {
        return false;
      }
    }
    return true;
  }

  componentDidMount() {
    this.modalConfig();

    this.props.showHideLoader(true);

    let params = queryString.parse(this.props.location.search);

    if (!this.state.private) {
      // this.props.getLocationResources(params.uuid, this.state.searchDateVal);
      this.setState({
        locationTimezone: this.props.locations.results[0].attributes.timezone,
        bookingColors: getBookingColors(
          this.props.locations.results[0].attributes.booking_calendar_colors
        ),
        allowLocResourcePublicBooking:
          this.props.locations.results[0].attributes
            .allow_loc_resource_public_booking,
      });
    } else {
      const { storeUserAccess } = this.props;
      let isDefaultUser =
        validateAccess(storeUserAccess, "DefaultUserMenu", "") &&
        validateAccess(storeUserAccess, "DefaultUserMenu", "userDetails");

      // this.props.getLocationList(
      //   { q: params.uuid },
      //   this.props.authUser.sessionToken
      // );

      // this.props.getLocationResourcesPrivate(
      //   params.uuid,
      //   { is_active: 1, display_online: 1, date: this.state.searchDateVal },
      //   this.props.authUser.sessionToken
      // );

      this.setState({ isDefaultUser: isDefaultUser });
      if (isDefaultUser) {
        // this.props.getCustomers(
        //   { limit: 1, customerLocationUuid: params.uuid },
        //   this.props.authUser.sessionToken
        // );
      }

      this.doSwitchCalendar(true, new Date());
    }

    // this.resourceIntervalId = setInterval(
    //   this.isResourceLoaded.bind(this),
    //   500
    // );
    if (this.state.private) {
      this.props.getStatuses(this.props.authUser.sessionToken);
    }

    this.generateVoucher = false;

    // --- Mobile
    window.addEventListener("scroll", this.onScroll);

    this.popupStatusClass = "";

    this.handleSwitchCalendar = this.handleSwitchCalendar.bind(this);
  }

  getUserCalendar(params) {
    this.props.getUserCalendar(params, this.props.authUser.sessionToken);
  }

  isResourceLoaded() {
    const { locationResourcesLoaded } = this.state;
  }

  refreshCalendar() {
    const { showBookingDetailsModal, showBookingModal } = this.state;

    // Skipped refreshing when calendar is not active
    if (showBookingModal || showBookingDetailsModal) {
      clearInterval(this.intervalId);
      this.intervalId = null;
      this.props.showHideLoader(false);
      return;
    }

    let date = this.selectedDateVar;
    let formattedDate = moment(date).format("YYYY-MM-DD");
    let params = queryString.parse(this.props.location.search);

    this.props.selectDate(date);
    this.setState({
      searchDateVal: formattedDate,
      isClientSideFilter: false,
      ClientSidefilterCompleted: false,
      locationResourcesLoaded: false,
    });
    if (this.state.private) {
      // this.props.getLocationResourcesPrivate(
      //   params.uuid,
      //   { is_active: 1, display_online: 1, date: this.state.searchDateVal },
      //   this.props.authUser.sessionToken
      // );
      this.doSwitchCalendar(this.state.switchCalendar, date);
    }
    // else {
    //   this.props.getLocationResources(params.uuid, formattedDate);
    // }
  }

  componentWillUnmount() {
    clearInterval(this.intervalId);

    // -- Mobile
    window.removeEventListener("scroll", this.onScroll);
  }

  startCalendarRefresh = () => {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
    if (this.isCanRefresh) {
      this.intervalId = setInterval(this.refreshCalendar.bind(this), 5000);
    } else {
      this.refreshCalendar();
    }
  };

  createCourtTypeOptions = () => {
    let options = [];
    options.push({
      checked: false,
      disabled: false,
      text: "Select Resource Type",
      value: "",
    });
    if (
      this.props.locationResources.search_aggs !== undefined &&
      this.props.locationResources.search_aggs.resource_type !== undefined
    ) {
      let buckets =
        this.props.locationResources.search_aggs.resource_type.buckets;
      for (let i = 0; i < buckets.length; i++) {
        options.push({
          checked: false,
          disabled: false,
          text: buckets[i].key,
          value: buckets[i].key,
        });
      }
    }
    // this.setState({ isCourtTypeLoaded: true });
    return options;
  };

  createSurfaceTypeOptions = () => {
    let options = [];
    options.push({
      checked: false,
      disabled: false,
      text: "Select Surface Type",
      value: "",
    });
    if (
      this.props.locationResources.search_aggs !== undefined &&
      this.props.locationResources.search_aggs.surface_type !== undefined
    ) {
      let buckets =
        this.props.locationResources.search_aggs.surface_type.buckets;
      for (let i = 0; i < buckets.length; i++) {
        options.push({
          checked: false,
          disabled: false,
          text: buckets[i].key,
          value: buckets[i].key,
        });
      }
    }
    // this.setState({ isSurfaceTypeLoaded: true });
    return options;
  };

  debouncedDropdownLoaded = _.debounce(function () {
    this.setState({
      isCourtTypeLoaded: true,
      isSurfaceTypeLoaded: true,
    });
  }, 10);

  componentDidUpdate(prevProps, prevState) {
    this.validateCalendarRendering(prevProps, prevState);
    // this.couponValidation(prevProps, prevState);
    // this.bookingStatusRenderValidation(prevProps, prevState);
    // this.validateOnVoucherIssuedSuccess(prevProps, prevState);
    // this.validatePrices(prevProps, prevState);
    // this.validateBookingResponse(prevProps, prevState);
    // this.getCustomerResult(prevProps, prevState);
    // this.validateRequestPaymentResponse(prevProps, prevState);
    this.validateCalendarNav(prevProps, prevState);

    if (
      prevProps.isCloseBooking !== this.props.isCloseBooking &&
      this.props.isCloseBooking
    ) {
      this.debouncedReRunRefreshCalendar();
    }

    // if (this.state.isLocationPerMembership && this.state.triggerPricing) {
    //   this.setState({
    //     triggerPricing: false,
    //   });
    //   this.calculatePrice();
    // }

    // this.validateBookingConflicts(prevProps, prevState);
    // this.subcribeResponse(prevProps, prevState);
    // this.getPublicLocation(prevProps, prevState);
    this.getResourceResponse(prevProps, prevState);
  }

  getResourceResponse(prevProps, prevState) {
    if (
      prevProps.getResourceResponse !== this.props.getResourceResponse &&
      this.props.getResourceResponse.status === 200
    ) {
      this.setState({
        locationResource: this.props.getResourceResponse.data,
        showBookingDetailsModal: true,
      });
    }
  }

  validateOverwriteFee(prevProps, prevState) {
    if (
      this.state.locationObj.id !== undefined &&
      (prevState.overwriteFee !== this.state.overwriteFee ||
        prevState.overwriteFeeAmount !== this.state.overwriteFeeAmount)
    ) {
      this.calculatePrice();
    }
  }

  getPublicLocation(prevProps, prevState) {
    if (prevProps.locations !== this.props.locations) {
      let allowLocResourcePublicBooking = "No";

      if (this.props.locations.results !== undefined) {
        allowLocResourcePublicBooking =
          this.props.locations.results[0].attributes
            .allow_loc_resource_public_booking;
      }

      this.setState({
        allowLocResourcePublicBooking: allowLocResourcePublicBooking,
      });
    }
  }

  subcribeResponse(prevProps, prevState) {
    if (prevProps.userResponse !== this.props.userResponse) {
      let response = this.props.userResponse;
      if (
        response.action == "ACTION" &&
        response.type === "SUBSCRIBE_RESPONSE_HANDLER"
      ) {
        this.props.showNotification(
          response.notificationType,
          response.data.message
        );
      }
    }
  }

  validateBookingConflicts = (prevProps, prevState) => {
    let bookingResponse = this.props.bookingResponse;
    if (prevProps.bookingResponse !== bookingResponse) {
      if (
        bookingResponse.action == "CONFLICTS" &&
        bookingResponse.page == "calendar"
      ) {
        let warnings = bookingResponse.data.conflicts;
        let validationMessages = bookingResponse.data.validationMessages;
        this.submitBookingHandler(warnings, validationMessages);
      }
    }
  };

  validateCalendarNav(prevProps, prevState) {
    if (!this.state.private) {
      // this.setState({
      //   calendarPrevNavDisable: false,
      //   calendarNextNavDisable: false,
      // });
      if (prevProps.selectedDate !== this.props.selectedDate) {
        if (
          moment(this.props.selectedDate, "YYYY-MM-DD").isSameOrBefore(
            new Date(),
            "YYYY-MM-DD"
          )
        ) {
          this.setState({
            calendarPrevNavDisable: true,
          });
        } else {
          this.setState({
            calendarPrevNavDisable: false,
          });
        }

        if (
          moment(this.props.selectedDate, "YYYY-MM-DD").isSameOrAfter(
            moment(
              moment(new Date()).add(30, "days").format("YYYY-MM-DD"),
              "YYYY-MM-DD"
            )
          )
        ) {
          this.setState({
            calendarNextNavDisable: true,
          });
        } else {
          this.setState({
            calendarNextNavDisable: false,
          });
        }
      }
    }
  }

  validateRequestPaymentResponse(prevProps, prevState) {
    // this.props.paymentRequestSuccess.status
    // paymentRequestFailed
    if (prevProps.paymentRequestSuccess !== this.props.paymentRequestSuccess) {
      if (this.state.isDefaultUser) {
        if (this.props.paymentRequestSuccess.status === 200) {
          if (
            this.props.paymentRequestSuccess.data.ispaid !== undefined &&
            this.props.paymentRequestSuccess.data.ispaid
          ) {
            window.location.replace(
              "/booking/success/" +
                this.props.paymentRequestSuccess.data.bookingData.bookingUuid
            );
          } else {
            this.props.showHideLoader(false);
            this.props.history.push("/payment");
          }
        }
      } else {
        let msg = "Booking has been saved. Payment request sent!";
        this.props.showNotification("success", msg);
        this.props.showHideLoader(false);
        // this.resetBookingModal();
      }
    }
    if (prevProps.paymentRequestFailed !== this.props.paymentRequestFailed) {
      this.props.showHideLoader(false);

      let msg = "";

      if (this.props.paymentRequestFailed === "Network error") {
        msg =
          "Unable to save booking. Please try again later or contact system administrator.";
      } else {
        msg = this.props.paymentRequestFailed.data.message;
      }

      this.props.showNotification("error", msg);
      // this.resetBookingModal();
    }
  }

  // validateGetOriginaPrice(prevProps,prevState) {
  //   if (
  //     prevProps.successHandlerResponse !== this.props.successHandlerResponse
  //   ) {
  //     if (
  //       this.props.successHandlerResponse !== null &&
  //       this.props.successHandlerResponse.status === 200
  //     ) {
  //       this.props.showHideLoader(false);
  //       this.debouncedSetPrice(
  //         this.props.successHandlerResponse.data.totalPrice
  //       );
  //       this.setState({
  //         couponDiscount: this.props.successHandlerResponse.data.couponDiscount,
  //       });
  //     }
  //   }
  // }

  validateBookingResponse(prevProps, prevState) {
    //-- Success Response
    if (
      prevProps.bookingSuccessResponse !== this.props.bookingSuccessResponse &&
      this.props.bookingSuccessResponse.status === 200 &&
      this.props.bookingSuccessResponse.iscreate
    ) {
      let msg = this.state.isUpdate
        ? "Updated booking details"
        : "Customer has been booked!";

      this.props.showNotification("success", msg);
      this.props.showHideLoader(false);
      // this.resetBookingModal();
    }

    //-- Failed Response
    if (
      prevProps.bookingFailedResponse !== this.props.bookingFailedResponse &&
      this.props.bookingFailedResponse.status >= 400 &&
      this.props.bookingFailedResponse.iscreate
    ) {
      if (
        this.props.bookingFailedResponse.data !== undefined &&
        this.props.bookingFailedResponse.data.errorMessages !== undefined &&
        this.props.bookingFailedResponse.data.errorMessages.length > 0
      ) {
        this.props.showHideLoader(false);
        this.props.showNotification(
          "error",
          this.props.bookingFailedResponse.data.errorMessages[0]
        );
      } else {
        this.props.showHideLoader(false);
        this.props.showNotification(
          "error",
          this.props.bookingFailedResponse.data.message
        );
      }

      this.setState({ disableSaveButton: false, disableStatusButton: false });
      this.props.clearBookingFailedResponse();
    }
    // else if (this.state.invalidCoupon) {
    //   this.props.showHideLoader(false);
    //   return (
    //     <MDBAlert color="danger" className="text-center">
    //       Invalid Discount code provided
    //     </MDBAlert>
    //   );
    // }
    else if (
      prevProps.bookingFailedResponse !== this.props.bookingFailedResponse &&
      this.props.bookingFailedResponse === "Network error"
    ) {
      this.props.showHideLoader(false);

      let msg = this.state.isUpdate
        ? "Unable to update details. Please try again later"
        : "Unable to book customer. Please try again later";

      this.props.showNotification("error", msg);

      this.setState({ disableSaveButton: false, disableStatusButton: false });
      this.props.clearBookingFailedResponse();
    }
  }

  bookingStatusRenderValidation(prevProps, prevState) {
    if (
      prevProps.getBookingStatusSuccessResponse !==
      this.props.getBookingStatusSuccessResponse
    ) {
      if (this.props.getBookingStatusSuccessResponse.status === 200) {
        let bookingStatusHistoryElem = this.buildStatusHistory(
          this.props.getBookingStatusSuccessResponse
        );
        this.setState({ bookingStatusHistoryElem: bookingStatusHistoryElem });
      }
    }
  }

  debouncedSetPrice = _.debounce(function (price) {
    this.setState({
      totalPrice: price.totalPrice,
      origPrice: price.originalPrice,
      chargeAmount: price.chargePrice,
      unPaidAmount: price.unpaidAmount,
      lessAmount: price.refundAmount,
      couponDiscount: price.couponDiscount,
      showPriceChangeWarning: price.totalPrice !== price.originalPrice,
    });
  }, 10);

  couponValidation(prevProps, prevState) {
    if (this.state.showBookingModal && prevState.time !== this.state.time) {
      this.calculatePrice();
    }

    if (this.state.showBookingModal && prevState.coupon !== this.state.coupon) {
      this.debouncedCalculatePrice();
    }

    if (
      prevProps.successHandlerResponse !== this.props.successHandlerResponse
    ) {
      if (
        this.props.successHandlerResponse !== null &&
        this.props.successHandlerResponse.status === 200
      ) {
        this.props.showHideLoader(false);
        this.debouncedSetPrice(this.props.successHandlerResponse.data);
        this.setState({
          couponDiscount: this.props.successHandlerResponse.data.couponDiscount,
        });

        // // -- Get original price
        // if (
        //   this.state.showBookingDetailsModal &&
        //   !this.state.doneGettingOriginalPrice
        // ) {
        //   this.setState({
        //     origPrice: this.props.successHandlerResponse.data.totalPrice,
        //     doneGettingOriginalPrice: true,
        //   });
        // }
      }
    }

    if (prevProps.failedHandlerResponse !== this.props.failedHandlerResponse) {
      if (
        this.props.failedHandlerResponse !== null &&
        this.props.failedHandlerResponse.status === 400
      ) {
        if (
          this.props.failedHandlerResponse.data.errorMessages !== undefined &&
          this.props.failedHandlerResponse.data.errorMessages.length > 0
        ) {
          this.setState({
            couponErrorMsg:
              this.props.failedHandlerResponse.data.errorMessages[0],
            invalidCoupon: true,
          });
        }

        this.props.showHideLoader(false);
        this.debouncedSetPrice(this.props.failedHandlerResponse.data);
        this.setState({
          couponDiscount: this.props.failedHandlerResponse.data.couponDiscount,
        });
      }
    }
  }

  enrichBookingResponselvl2(results) {
    let formattedResults = [];

    //-- correct start and end time
    _.map(results, (book) => {
      let bookObj = book;
      let relatedBookings = _.uniqBy(book.relatedBookings, function (e) {
        return e.id;
      });

      let startDateArr = [];
      let endDateArr = [];

      bookObj["relatedBookings"] = relatedBookings;

      _.map(relatedBookings, (book) => {
        startDateArr.push(book.start_time);
        endDateArr.push(book.end_time);
      });

      startDateArr = _.sortedUniq(startDateArr);
      endDateArr = _.sortedUniq(endDateArr);

      bookObj["start_time"] = startDateArr[0];
      bookObj["end_time"] = endDateArr[endDateArr.length - 1];
      formattedResults.push(bookObj);
    });

    let enrichedResults = formattedResults;
    let counter = 0;
    _.map(formattedResults, (book) => {
      counter++;
      if (counter === 1) {
        enrichedResults.push(book);
      }
      let bookedDate = moment(book.start_time).format("YYYY-MM-DD");

      let localStartTime = moment(book.start_time).format("HH:mm");

      let localEndTime = moment(book.end_time).format("HH:mm");

      //-- Iterate other bookings
      _.map(formattedResults, (otherBook) => {
        //-- Check if in the same booking range
        let oBookedDate = moment(otherBook.start_time).format("YYYY-MM-DD");

        let oLocalStartTime = moment(otherBook.start_time).format("HH:mm");
        let oLocalEndTime = moment(otherBook.end_time).format("HH:mm");
        if (
          bookedDate === oBookedDate &&
          otherBook.booking_reference !== book.booking_reference &&
          moment(localStartTime, "HH:mm").isSameOrAfter(
            moment(oLocalStartTime, "HH:mm")
          ) &&
          moment(localStartTime, "HH:mm").isSameOrBefore(
            moment(oLocalEndTime, "HH:mm")
          )
        ) {
          let enrichedBook = book;
          //-- check first if this booking is already existing on enrichedResults
          let isFound = false;
          let index = -1;
          _.map(enrichedResults, (er) => {
            index++;
            //-- check related booking
            let alreadyInThisBooking = false;
            _.map(er.relatedBookings, (rb) => {
              if (
                rb.booking_reference === otherBook.booking_reference ||
                rb.booking_reference === book.booking_reference
              ) {
                alreadyInThisBooking = true;
              }
            });

            if (alreadyInThisBooking) {
              isFound = true;
              enrichedResults[index]["relatedBookings"].push(book);
            }
          });

          if (!isFound) {
            enrichedBook["relatedBookings"] = [otherBook];
            enrichedResults.push(enrichedBook);
          }
        }
      });
    });

    let index = -1;
    _.map(enrichedResults, (book) => {
      index++;
      let relatedBookings = _.uniqBy(book.relatedBookings, function (e) {
        return e.id;
      });
      enrichedResults[index]["relatedBookings"] = relatedBookings;
    });

    enrichedResults = _.uniqBy(enrichedResults, function (e) {
      return e.booking_reference;
    });

    return enrichedResults;
  }

  enrichBookingResponse(response) {
    let results = response.data.bookings.results;
    let enrichedResults = [];

    _.map(results, (book) => {
      let bookedDate = moment(book.start_time).format("YYYY-MM-DD");

      let localStartTime = moment(book.start_time).format("HH:mm");

      let localEndTime = moment(book.end_time).format("HH:mm");

      //-- Iterate other bookings
      _.map(results, (otherBook) => {
        //-- Check if in the same booking range
        let oBookedDate = moment(otherBook.start_time).format("YYYY-MM-DD");

        let oLocalStartTime = moment(otherBook.start_time).format("HH:mm");
        let oLocalEndTime = moment(otherBook.end_time).format("HH:mm");

        if (
          bookedDate === oBookedDate &&
          otherBook.booking_reference !== book.booking_reference &&
          moment(localStartTime, "HH:mm").isSameOrAfter(
            moment(oLocalStartTime, "HH:mm")
          ) &&
          moment(localStartTime, "HH:mm").isSameOrBefore(
            moment(oLocalEndTime, "HH:mm")
          )
        ) {
          let enrichedBook = book;

          //-- check first if this booking is already existing on enrichedResults
          let isFound = false;
          let index = -1;
          _.map(enrichedResults, (er) => {
            index++;
            //-- check related booking
            let alreadyInThisBooking = false;
            _.map(er.relatedBookings, (rb) => {
              if (
                rb.booking_reference === otherBook.booking_reference ||
                rb.booking_reference === book.booking_reference
              ) {
                alreadyInThisBooking = true;
              }
            });

            if (alreadyInThisBooking) {
              isFound = true;
              enrichedResults[index]["relatedBookings"].push(book);
              enrichedResults[index]["relatedBookings"].push(otherBook);
            }
          });

          if (!isFound) {
            enrichedBook["relatedBookings"] = [otherBook, book];
            // enrichedBook["relatedBookings"] = [book];
            enrichedResults.push(enrichedBook);
          }
        }
      });
    });
    enrichedResults = this.enrichBookingResponselvl2(enrichedResults);

    _.map(response.data.bookings.results, (book) => {
      enrichedResults.push(book);
    });

    enrichedResults = _.uniqBy(enrichedResults, function (e) {
      return e.booking_reference;
    });

    _.sortBy(enrichedResults, "start_date");

    response.data.bookings.results = enrichedResults;

    return response;
  }

  validateCalendarRendering(prevProps, prevState) {
    if (
      prevProps.bookingResponse !== this.props.bookingResponse &&
      this.props.bookingResponse.type === "GET_USER_CALENDAR"
    ) {
      const { browserSize } = this.props;
      let generatedTimeContainer = this.generateTime({
        minTime: this.state.minTime,
        maxTime: this.state.maxTime,
      });

      let response = this.enrichBookingResponse(this.props.bookingResponse);
      // --- Enrich bookingResponse to support multiple bookings with same slot

      let tableElem = undefined;
      let tableElemForMobile = false;
      if (browserSize.lessThan.medium) {
        tableElem = this.mobileBuildTableElem(generatedTimeContainer, response);
        tableElemForMobile = true;
      } else {
        tableElem = this.buildTableElem(generatedTimeContainer, response);
        tableElemForMobile = false;
      }

      // let recurrings = [];
      // this.props.locationResources.results.forEach((value, index) => {
      //   value.recurrings.forEach((recurring, index) => {
      //     recurrings.push(recurring);
      //   });
      // });

      this.setState({
        // recurrings: recurrings,
        // locationResourcesContainer: this.props.locationResources,
        // origLocationResourcesContainer: _.cloneDeep(
        //   this.props.locationResources
        // ),
        // locationResourcesLoaded: true,
        // courtTypeOptions: this.createCourtTypeOptions(),
        // surfaceTypeOptions: this.createSurfaceTypeOptions(),
        // doDropdownFilter: false,
        generatedTimeContainer: generatedTimeContainer,
        tableElem: tableElem,
        tableElemForMobile: tableElemForMobile,
      });

      if (!this.isCanRefresh) {
        this.isCanRefresh = true;
        this.startCalendarRefresh();
      }

      this.props.showHideLoader(false);
      // }
    }
  }

  filterLocationResources() {
    let filteredData = _.cloneDeep(this.state.origLocationResourcesContainer);

    if (this.state.selectedResource !== "Select Resource Type") {
      filteredData.results = _.chain(filteredData.results)
        .map((result) => {
          if (result.attributes.resource_type === this.state.selectedResource) {
            return result;
          }
          return [];
        })
        .filter(_.size)
        .value();
    }

    if (this.state.selectedSurface !== "Select Surface Type") {
      filteredData.results = _.chain(filteredData.results)
        .map((result) => {
          if (result.attributes.surface_type === this.state.selectedSurface) {
            return result;
          }
          return [];
        })
        .filter(_.size)
        .value();
    }

    // filteredData.results = [filteredData.results[0]];
    this.setState({ ClientSidefilterCompleted: true });
    return filteredData;
  }

  generateTime(obj) {
    let minTime = obj.minTime;
    let maxTime = obj.maxTime;

    let addedTime = minTime;

    let formattedTimeArr = [];
    let toFormatObj = {};

    let counter = 0;
    if (
      moment(addedTime, "HH:mm").isValid() &&
      moment(maxTime, "HH:mm").isValid()
    ) {
      while (addedTime !== maxTime) {
        counter++;
        if (counter !== 1) {
          addedTime = moment(addedTime, "HH:mm")
            .add(30, "minutes")
            .format("HH:mm");
        }
        if (toFormatObj.start === undefined) {
          toFormatObj["start"] = addedTime;
        } else if (
          toFormatObj.start !== undefined &&
          toFormatObj.end === undefined
        ) {
          toFormatObj["end"] = addedTime;
        }

        if (toFormatObj.start !== undefined && toFormatObj.end !== undefined) {
          formattedTimeArr.push(toFormatObj.start + "-" + toFormatObj.end);
          addedTime = toFormatObj.start;
          toFormatObj = {};
        }
      }
    }

    return formattedTimeArr;
  }

  testReturnH1(text) {
    return (
      <div>
        <h1>{text}</h1>
      </div>
    );
  }

  renderTH(text, key, className, width) {
    return (
      <th key={key} className={className} width={width + "%"}>
        <strong>{text}</strong>
      </th>
    );
  }

  calendarNav(isNext) {
    let date = null;
    if (isNext) {
      let ddate = this.props.selectedDate;
      if (!this.state.switchCalendar) {
        ddate = moment(ddate).endOf("isoWeek");
      }
      date = moment(ddate).add(1, "days").toDate();
    } else {
      let ddate = this.props.selectedDate;
      if (!this.state.switchCalendar) {
        ddate = moment(ddate).startOf("isoWeek").subtract(6, "days").toDate();
      }
      date = moment(ddate).subtract(1, "days").toDate();
    }
    this.setState({
      isClientSideFilter: false,
      ClientSidefilterCompleted: false,
      locationResourcesLoaded: false,
    });
    this.debouncedSelectedDate(date);
    this.doSwitchCalendar(this.state.switchCalendar, date);
  }

  clearRefreshCalendarTimer() {
    clearInterval(this.intervalId);
    this.debouncedReRunRefreshCalendar();
  }

  debouncedReRunRefreshCalendar = _.debounce(function () {
    this.intervalId = setInterval(this.refreshCalendar.bind(this), 5000);
  }, 5000);

  renderTHNav(text, key, className, isNext) {
    const { calendarPrevNavDisable } = this.state;
    let calendarNextNavDisable = this.state.calendarNextNavDisable;
    if (isNext) {
      if (this.overrideCalendarNextNavDisable) {
        calendarNextNavDisable = this.overrideCalendarNextNavDisable;
        this.overrideCalendarNextNavDisable = undefined;
      }
      return (
        <th key={key} className={className}>
          <MDBBtn
            color="grey darken-1"
            size="sm"
            style={{ margin: "0" }}
            onClick={() => this.calendarNav(true)}
            onMouseEnter={() => this.clearRefreshCalendarTimer()}
            disabled={calendarNextNavDisable}
          >
            <MDBIcon icon="angle-double-right" />
          </MDBBtn>
        </th>
      );
    } else {
      return (
        <th key={key} className={className}>
          <MDBBtn
            color="grey darken-1"
            size="sm"
            style={{ margin: "0" }}
            onClick={() => this.calendarNav(false)}
            onMouseEnter={() => this.clearRefreshCalendarTimer()}
            disabled={calendarPrevNavDisable}
          >
            <MDBIcon icon="angle-double-left" />
          </MDBBtn>
        </th>
      );
    }
  }

  renderTD(text, key) {
    const { bookingColors } = this.state;
    if (!this.state.private) {
      return (
        <td
          key={key}
          className={
            text.length === 0
              ? getCss(bookingColors.bg_public_notAvailable)
              : ""
          }
        >
          <strong>{text}</strong>
        </td>
      );
    } else {
      if (text.length === 0) {
        return (
          <td key={key} className={getCss(bookingColors.bg_notAvailable)}></td>
        );
      }
      return (
        <td key={key}>
          <strong>{text}</strong>
        </td>
      );
    }
  }

  renderTD(text, key, width) {
    const { bookingColors } = this.state;
    if (!this.state.private) {
      return (
        <td
          key={key}
          className={
            text.length === 0
              ? getCss(bookingColors.bg_public_notAvailable)
              : ""
          }
          style={{ width: width + "%" }}
        >
          <strong>{text}</strong>
        </td>
      );
    } else {
      if (text.length === 0) {
        return (
          <td
            key={key}
            style={{ width: width + "%" }}
            className={getCss(bookingColors.bg_public_notAvailable)}
          ></td>
        );
      }
      return (
        <td key={key} style={{ width: width + "%" }}>
          <strong>{text}</strong>
        </td>
      );
    }
  }

  renderMultipleBookedTD(paramData, booked) {
    const { bookingColors } = this.state;
    const { storeUserAccess } = this.props;
    let isStartTime = false;
    let rowSpan = 1;
    let bookObj = booked;
    let genStartTime = _.split(paramData.time, "-")[0];

    let localStartTime = moment(bookObj.start_time)
      .tz(this.getTzDetails().timezone)
      .format("HH:mm");

    let t1 = moment(bookObj.start_time);
    let t2 = moment(bookObj.end_time);

    let duration = t2.diff(t1, "minutes");
    rowSpan = duration / 30;

    if (genStartTime === localStartTime) {
      isStartTime = true;
    }

    // -- TODO Temporary validation
    let noCustomerDetails = false;
    if (bookObj.customer === undefined) {
      // if (bookObj.customer.email !== "test1@test.com") {
      noCustomerDetails = true;
    }

    let padding = (20 * rowSpan) / booked.relatedBookings.length;

    //-- Check if the main booking is in relatedBookings

    // let hasMain = _.find(booked.relatedBookings, function (o) {
    //   return o.booking_reference == bookObj.booking_reference;
    // });

    // if (hasMain === undefined || hasMain.length === 0) {
    //   booked.relatedBookings.push(bookObj);
    // }

    if (isStartTime) {
      if (validateAccess(storeUserAccess, "AdminBooking", "viewBooking")) {
        let elem = [];
        let counter = 0;
        _.map(booked.relatedBookings, (book) => {
          counter++;
          let isRecurring =
            book.parent_booking !== undefined || book.recurring !== undefined;

          let tdColor = "",
            tdTextColor = "",
            tdColorClickable = "";

          if (!noCustomerDetails) {
            tdColor = isRecurring
              ? getCss(bookingColors.bg_recurring)
              : getCss(bookingColors.bg_oneOff);
            tdTextColor = isRecurring
              ? getCss(bookingColors.tc_recurring)
              : getCss(bookingColors.tc_oneOff);
            tdColorClickable = isRecurring
              ? getCss(bookingColors.bg_recurring)
              : getCss(bookingColors.bg_oneOff);
          } else {
            tdColor = getCss(bookingColors.bg_notAvailable);
            tdTextColor = getCss(bookingColors.tc_notAvailable);
            tdColorClickable = getCss(bookingColors.bg_notAvailable);
          }

          let startTime = moment(book.start_time)
            .tz(this.getTzDetails().timezone)
            .format("HH:mm");

          let endTime = moment(book.end_time)
            .tz(this.getTzDetails().timezone)
            .format("HH:mm");

          elem.push(
            <div
              key={"divkey" + counter}
              onClick={() => this.openBookingDetailsModalForm(book)}
              className={`${tdColorClickable}`}
              style={{
                cursor: "pointer",
                padding: padding,
                position: "relative",
              }}
            >
              {this.displayIcon(book)}
              <strong className={tdTextColor}>
                {book.location.name} @ {startTime + " - " + endTime}
              </strong>
            </div>
          );
        });

        return (
          <td
            rowSpan={rowSpan}
            style={{
              padding: "0",
              backgroundColor: "#dcdada",
              position: "relative",
            }}
            key={paramData.key}
            // style={{ cursor: "pointer" }}
            // onClick={() => this.openBookingDetailsModalForm(bookObj)}
          >
            {elem}
          </td>
        );
      }
    } else {
      return <></>;
    }
  }

  renderBookedTD(paramData, booked) {
    const { bookingColors } = this.state;
    const { storeUserAccess } = this.props;
    let isStartTime = false;
    let rowSpan = 1;
    // let bookObj = booked[0];
    let bookObj = booked;
    let genStartTime = _.split(paramData.time, "-")[0];

    let localStartTime = moment(bookObj.start_time)
      .tz(this.getTzDetails().timezone)
      .format("HH:mm");

    // let bookedDate = moment(bookObj.start_time)
    //   .tz(this.getTzDetails().timezone)
    //   .format("YYYY-MM-DD");

    let t1 = moment(bookObj.start_time);
    let t2 = moment(bookObj.end_time);

    let duration = t2.diff(t1, "minutes");
    rowSpan = duration / 30;

    if (genStartTime === localStartTime) {
      isStartTime = true;
    }

    if (!this.state.private) {
      if (isStartTime) {
        return (
          <td
            className={getCss(bookingColors.bg_public_booked)}
            rowSpan={rowSpan}
            key={paramData.key}
          >
            <strong className={getCss(bookingColors.tc_public_booked)}>
              Booked
            </strong>
          </td>
        );
      }
      return <></>;
    } else {
      // -- TODO Temporary validation
      let noCustomerDetails = false;
      if (bookObj.customer === undefined) {
        // if (bookObj.customer.email !== "test1@test.com") {
        noCustomerDetails = true;
      }

      let isRecurring =
        bookObj.parent_booking !== undefined || bookObj.recurring !== undefined;

      let tdColor = "",
        tdTextColor = "",
        tdColorClickable = "";

      if (!noCustomerDetails) {
        tdColor = isRecurring
          ? getCss(bookingColors.bg_recurring)
          : getCss(bookingColors.bg_oneOff);
        tdTextColor = isRecurring
          ? getCss(bookingColors.tc_recurring)
          : getCss(bookingColors.tc_oneOff);
        tdColorClickable = isRecurring
          ? getCss(bookingColors.bg_recurring)
          : getCss(bookingColors.bg_oneOff);
      } else {
        tdColor = getCss(bookingColors.bg_notAvailable);
        tdTextColor = getCss(bookingColors.tc_notAvailable);
        tdColorClickable = getCss(bookingColors.bg_notAvailable);
      }

      if (this.props.isChangeSchedule && this.props.showCalendarSelect) {
        if (isStartTime) {
          if (noCustomerDetails) {
            return (
              <td
                rowSpan={rowSpan}
                className={tdColorClickable}
                key={paramData.key}
              >
                <strong className={tdTextColor}>Booked</strong>
              </td>
            );
          }
          return (
            <td rowSpan={rowSpan} className={`${tdColor}`} key={paramData.key}>
              {this.displayIcon(bookObj)}
              <strong className={tdTextColor}>
                {bookObj.customer.first_name + " " + bookObj.customer.last_name}
              </strong>
            </td>
          );
        }
        return <></>;
      }
      if (isStartTime) {
        if (noCustomerDetails) {
          return (
            <td
              rowSpan={rowSpan}
              className={tdColorClickable}
              key={paramData.key}
            >
              <strong className={tdTextColor}>
                Booked THIS IS OTHER CUSTOMER BOOKED
              </strong>
            </td>
          );
        }
        if (validateAccess(storeUserAccess, "AdminBooking", "viewBooking")) {
          return (
            <td
              rowSpan={rowSpan}
              className={`${tdColorClickable}`}
              key={paramData.key}
              style={{ cursor: "pointer" }}
              onClick={() => this.openBookingDetailsModalForm(bookObj)}
            >
              {this.displayIcon(bookObj)}
              <strong className={tdTextColor}>{bookObj.location.name}</strong>
            </td>
          );
        }
        return (
          <td
            rowSpan={rowSpan}
            className={tdColorClickable}
            key={paramData.key}
          >
            {this.displayIcon(bookObj)}
            <strong className={tdTextColor}>
              {bookObj.customer.first_name + " " + bookObj.customer.last_name}
            </strong>
          </td>
        );
      } else {
        return <></>;
      }
    }
  }

  displayIcon(bookObj) {
    let isPaid =
      bookObj.transaction !== undefined &&
      bookObj.transaction.ispaid !== undefined &&
      bookObj.transaction.ispaid;

    let lastPaymentElem = bookObj.transaction.payments[0];

    let partiallyPaid =
      bookObj.transaction !== undefined &&
      bookObj.transaction.ispaid !== undefined &&
      bookObj.transaction.ispaid === 0 &&
      lastPaymentElem.voucherCreditAmount > 0;

    let unpaid =
      bookObj.transaction !== undefined &&
      bookObj.transaction.ispaid !== undefined &&
      bookObj.transaction.ispaid === 0 &&
      // lastPaymentElem.totalAmount === lastPaymentElem.subTotalAmount &&
      lastPaymentElem.voucherCreditAmount === 0;

    return (
      <div className="slotIconContainer">
        <MDBBadge pill color="secondary">
          {bookObj.status}
        </MDBBadge>

        {isPaid ? (
          <MDBBadge pill color="success">
            Paid
          </MDBBadge>
        ) : (
          <></>
        )}

        {partiallyPaid ? (
          <MDBBadge pill color="warning-color-dark">
            Partially Paid
          </MDBBadge>
        ) : (
          <></>
        )}

        {unpaid ? (
          <MDBBadge pill color="warning-color-dark">
            Unpaid
          </MDBBadge>
        ) : (
          <></>
        )}

        {bookObj.is_recurring === 1 ? (
          <MDBBadge pill color="primary">
            {bookObj.recurring_type}
          </MDBBadge>
        ) : (
          <></>
        )}

        {bookObj.is_recurring === 0 &&
        bookObj.parent_booking !== undefined &&
        bookObj.parent_booking.recurring_type !== undefined ? (
          <MDBBadge pill color="primary">
            {bookObj.parent_booking.recurring_type}
          </MDBBadge>
        ) : (
          <></>
        )}
      </div>
    );
  }

  validateChildMultipleBookings(paramData, book) {
    let multipleBookings = [];
    let localStartTime = moment(book.start_time)
      .tz(this.getTzDetails().timezone)
      .format("HH:mm");
    let localEndTime = moment(book.end_time)
      .tz(this.getTzDetails().timezone)
      .format("HH:mm");
    let bookedDate = moment(book.start_time)
      .tz(this.getTzDetails().timezone)
      .format("YYYY-MM-DD");

    _.map(paramData.bookings, (otherBook) => {
      // Convert date time to browser date
      var oLocalStartTime = moment(otherBook.start_time)
        .tz(this.getTzDetails().timezone)
        .format("HH:mm");
      var oLocalEndTime = moment(otherBook.end_time)
        .tz(this.getTzDetails().timezone)
        .format("HH:mm");

      if (
        otherBook.booking_reference !== book.booking_reference &&
        moment(localStartTime, "HH:mm").isSameOrAfter(
          moment(oLocalStartTime, "HH:mm")
        ) &&
        moment(localStartTime, "HH:mm").isSameOrBefore(
          moment(oLocalEndTime, "HH:mm")
        )
      ) {
        multipleBookings.push(otherBook);
      }
    });

    return multipleBookings;
  }

  validateMultipleBookings(paramData, book) {
    let multipleBookings = [];
    let localStartTime = moment(book.start_time)
      .tz(this.getTzDetails().timezone)
      .format("HH:mm");
    let localEndTime = moment(book.end_time)
      .tz(this.getTzDetails().timezone)
      .format("HH:mm");
    let bookedDate = moment(book.start_time)
      .tz(this.getTzDetails().timezone)
      .format("YYYY-MM-DD");

    _.map(paramData.bookings, (otherBook) => {
      // Convert date time to browser date
      var oLocalStartTime = moment(otherBook.start_time)
        .tz(this.getTzDetails().timezone)
        .format("HH:mm");
      var oLocalEndTime = moment(otherBook.end_time)
        .tz(this.getTzDetails().timezone)
        .format("HH:mm");

      let oBookedDate = moment(otherBook.start_time)
        .tz(this.getTzDetails().timezone)
        .format("YYYY-MM-DD");

      if (
        oBookedDate === paramData.date &&
        otherBook.booking_reference !== book.booking_reference &&
        moment(localStartTime, "HH:mm").isSameOrAfter(
          moment(oLocalStartTime, "HH:mm")
        ) &&
        moment(localStartTime, "HH:mm").isSameOrBefore(
          moment(oLocalEndTime, "HH:mm")
        )
      ) {
        multipleBookings.push(otherBook);
      }
    });
  }

  validateRenderingOfTD(paramData) {
    let genStartTime = _.split(paramData.time, "-")[0];
    let genEndTime = _.split(paramData.time, "-")[1];

    // if (
    //   moment(genStartTime, "HH:mm").isSameOrAfter(
    //     moment(paramData.defaultStartTime, "HH:mm")
    //   ) &&
    //   moment(genEndTime, "HH:mm").isSameOrBefore(
    //     moment(paramData.defaultEndTime, "HH:mm")
    //   )
    // ) {
    let booked = _.chain(paramData.bookings)
      .map((book) => {
        // Convert date time to browser date
        var localStartTime = moment(book.start_time)
          .tz(this.getTzDetails().timezone)
          .format("HH:mm");
        var localEndTime = moment(book.end_time)
          .tz(this.getTzDetails().timezone)
          .format("HH:mm");

        let bookedDate = moment(book.start_time)
          .tz(this.getTzDetails().timezone)
          .format("YYYY-MM-DD");

        if (
          bookedDate === paramData.date &&
          moment(genStartTime, "HH:mm").isSameOrAfter(
            moment(localStartTime, "HH:mm")
          ) &&
          moment(genEndTime, "HH:mm").isSameOrBefore(
            moment(localEndTime, "HH:mm")
          )
        ) {
          return book;
        }
        return [];
      })
      .filter(_.size)
      .value();

    if (booked.length > 0) {
      var bookObj = booked[0];
      let bookedDate = moment(bookObj.start_time)
        .tz(this.getTzDetails().timezone)
        .format("YYYY-MM-DD");

      if (bookedDate === paramData.date) {
        if (
          bookObj.relatedBookings !== undefined &&
          bookObj.relatedBookings.length > 0
        ) {
          return this.renderMultipleBookedTD(paramData, bookObj);
        }
        return this.renderBookedTD(paramData, bookObj);
      } else {
        return this.renderTD("", paramData.key);
      }
    }
    return this.renderTD("", paramData.key);
  }

  getTzDetails(dt = new Date()) {
    const { locationTimezone } = this.state;
    return extractTimezone(locationTimezone, dt);
  }

  validateNotAvailableTD(paramData) {
    let genStartTime = _.split(paramData.time, "-")[0];
    let defaultStartTime = paramData.defaultStartTime;
    let minDuration = new Number(
      _.replace(paramData.minDuration, "m", "")
    ).valueOf();
    let minusTime = moment(genStartTime, "HH:mm")
      .subtract(30, "minutes")
      .format("HH:mm");

    if (
      !this.state.private &&
      moment(minusTime, "HH:mm").isBefore(moment(defaultStartTime, "HH:mm"))
    ) {
      return this.renderTD("", paramData.key);
    } else {
      // return this.renderAvailableTD(paramData);
      let durationCounter = 0;
      let bookedStartTimeArr = _.chain(paramData.bookings)
        .map((book) => {
          return moment(book.start_time)
            .tz(this.getTzDetails().timezone)
            .format("HH:mm");
        })
        .sort()
        .reverse()
        .value();

      let minTime = "";

      for (let i = 0; i < bookedStartTimeArr.length; i++) {
        if (
          moment(genStartTime, "HH:mm").isAfter(
            moment(bookedStartTimeArr[i], "HH:mm")
          )
        ) {
          minTime = bookedStartTimeArr[i];
          break;
        }
      }

      let minusTime = genStartTime;
      if (minTime.length > 0) {
        while (minusTime !== minTime) {
          minusTime = moment(minusTime, "HH:mm")
            .subtract(30, "minutes")
            .format("HH:mm");
          durationCounter += 30;
        }

        if (!this.state.private && durationCounter < minDuration) {
          return this.renderTD("", paramData.key);
        } else {
          return this.renderAvailableTD(paramData);
        }
      } else {
        return this.renderAvailableTD(paramData);
      }
    }
  }
  // -------------------- MOBILE CODES ------------------ //

  goToTop() {
    window.scrollTo(0, 0);
    this.setState((prevState) => ({
      collapseID: "",
    }));
  }

  mobileToggleCollapse = (collapseID) => () =>
    this.setState((prevState) => ({
      collapseID: prevState.collapseID !== collapseID ? collapseID : "",
    }));

  mobileModalToggleCollapse = (modalCollapseID) => () =>
    this.setState((prevState) => ({
      modalCollapseID:
        prevState.modalCollapseID !== modalCollapseID ? modalCollapseID : "",
    }));

  onScroll = () => {
    this.setState({ isScrolling: true });

    clearTimeout(this.timeout);

    this.timeout = setTimeout(() => {
      this.setState({ isScrolling: false });
    }, 500);
  };

  onHover = () => {
    this.setState({
      buttonStyle: {
        transform: "scaleY(1) scaleX(1) translateY(0) translateX(0)",
        opacity: "1",
      },
    });
  };

  onMouseLeave = () => {
    this.setState({
      buttonStyle: {
        transform: "scaleY(0.4) scaleX(0.4) translateY(40px) translateX(0)",
        opacity: "0",
      },
    });
  };

  mobileActionButton() {
    const { calendarPrevNavDisable, calendarNextNavDisable } = this.state;
    return (
      <section
      // style={{ height: "1000px" }}
      >
        <MDBBtnFixed
          floating
          onClick={this.onHover}
          onMouseEnter={this.onHover}
          onMouseLeave={this.onMouseLeave}
          size="lg"
          color="blue"
          icon="pencil-alt"
          style={{ bottom: "45px", right: "13px" }}
        >
          <div style={{ position: "relative" }}>
            <MDBBtnFixedItem
              buttonStyle={this.state.buttonStyle}
              color="orange"
              icon="calendar-check"
              onClick={() => this.doGoToToday()}
              onMouseEnter={() => this.clearRefreshCalendarTimer()}
            />
            <div className="action-tooltips">Go to today</div>
          </div>

          <div style={{ position: "relative" }}>
            <MDBBtnFixedItem
              buttonStyle={this.state.buttonStyle}
              color="blue"
              icon="angle-double-left"
              onClick={() => this.calendarNav(false)}
              onMouseEnter={() => this.clearRefreshCalendarTimer()}
              disabled={calendarPrevNavDisable}
            />
            <div className="action-tooltips">Prev. Date</div>
          </div>
          <div style={{ position: "relative" }}>
            <MDBBtnFixedItem
              buttonStyle={this.state.buttonStyle}
              color="blue"
              icon="angle-double-right"
              onClick={() => this.calendarNav(true)}
              onMouseEnter={() => this.clearRefreshCalendarTimer()}
              disabled={calendarNextNavDisable}
            />
            <div className="action-tooltips">Next Date</div>
          </div>
          <div style={{ position: "relative" }}>
            <MDBBtnFixedItem
              onClick={() => this.goToTop()}
              buttonStyle={this.state.buttonStyle}
              color="green"
              icon="window-minimize"
            />
            <div className="action-tooltips">Minimize</div>
          </div>
        </MDBBtnFixed>
      </section>
    );
  }

  mobileHeaderSection() {
    const { courtTypeOptions, surfaceTypeOptions } = this.state;
    return (
      <div className={`calendarHeader`}>
        <MDBRow className={`${this.props.private ? "" : ""}`}>
          <MDBCol md="12">
            <MDBRow>
              <MDBCol md="12">
                <MDBTable borderless className="dateContainer">
                  <MDBTableBody>
                    <tr>
                      <td className="dateNav">{this.mobileRenderNav(false)}</td>
                      <td className="datePicker">{this.datePicker()}</td>
                      <td className="dateNav">{this.mobileRenderNav(true)}</td>
                    </tr>
                  </MDBTableBody>
                </MDBTable>
              </MDBCol>
              {/* <MDBCol sm="2" xs="2">
              {this.mobileRenderNav(false)}
            </MDBCol>
            <MDBCol sm="8" xs="8">
              {this.datePicker()}
            </MDBCol>
            <MDBCol sm="2" xs="2">
              {this.mobileRenderNav(true)}
            </MDBCol> */}

              {/* Disabled filtering for now, Will make it API base filtering */}
              {courtTypeOptions.length > 2 && (
                <MDBCol md="3" style={{ display: "none" }}>
                  <MDBSelect
                    outline
                    color="primary"
                    onClick={this.filterEnable}
                    getValue={this.getValueOfSelectCourtType}
                    getTextContent={this.getValueOfSelectCourtType}
                    options={courtTypeOptions}
                    label="Resource Type"
                  />
                </MDBCol>
              )}
              {surfaceTypeOptions.length > 2 && (
                <MDBCol md="3" style={{ display: "none" }}>
                  <MDBSelect
                    outline
                    color="primary"
                    onClick={this.filterEnable}
                    getValue={this.getValueOfSelectSurfaceType}
                    getTextContent={this.getValueOfSelectSurfaceType}
                    options={surfaceTypeOptions}
                    label="Surface Type"
                  />
                </MDBCol>
              )}
            </MDBRow>
          </MDBCol>
          {/* <MDBCol>
            <div className="float-right">{this.statusIndicator()}</div>
          </MDBCol> */}
        </MDBRow>
        {/* <span style={{ position: "absolute", bottom: "0", fontSize: "small" }}>
        Location current time:
        <br />
        <strong>
          {moment()
            .tz(this.getTzDetails().timezone)
            .format("DD/MM/YYYY HH:mm")}
        </strong>
      </span> */}
        <div className="float-right goToTodayCont">
          {/* {this.renderSubscribeButton()} */}
          <Switch onSwitch={this.handleSwitchCalendar} />
          <MDBBtn
            className="goToToday"
            size="sm"
            onClick={() => this.doGoToToday()}
            onMouseEnter={() => this.clearRefreshCalendarTimer()}
          >
            Go to Today
          </MDBBtn>
        </div>
        {/* <div className="pricing-note">
        Please click the <strong>View Pricing Button</strong> at the right
        side corner to see pricing details
      </div> */}
      </div>
    );
  }

  subscribe() {
    if (!this.state.private) {
      let params = queryString.parse(this.props.location.search);
      this.props.history.push("/register?uuid=" + params.uuid);
    } else {
      let body = {
        locationId: this.state.locationObj.id,
        subscribe: true,
      };
      this.props.subscribe(body, this.props.authUser.sessionToken);
    }
  }

  renderSubscribeButton() {
    if (this.state.isDefaultUser || !this.state.private) {
      return (
        <MDBBtn
          className=""
          color="success"
          size="sm"
          onClick={() => this.subscribe()}
        >
          Subscribe
        </MDBBtn>
      );
    }
    return <></>;
  }

  mobileRenderNav(isNext) {
    const { calendarPrevNavDisable, calendarNextNavDisable } = this.state;
    if (isNext) {
      return (
        <MDBBtn
          color="grey darken-1"
          size="sm"
          style={{ margin: "0" }}
          onClick={() => this.calendarNav(true)}
          onMouseEnter={() => this.clearRefreshCalendarTimer()}
          disabled={calendarNextNavDisable}
        >
          <MDBIcon icon="angle-double-right" />
        </MDBBtn>
      );
    } else {
      return (
        <MDBBtn
          color="grey darken-1"
          size="sm"
          style={{ margin: "0" }}
          onClick={() => this.calendarNav(false)}
          onMouseEnter={() => this.clearRefreshCalendarTimer()}
          disabled={calendarPrevNavDisable}
        >
          <MDBIcon icon="angle-double-left" />
        </MDBBtn>
      );
    }
  }

  mobileResourceAcordtion() {
    const { collapseID, tableElem } = this.state;
    let elements = [];
    _.map(tableElem, (elem) => {
      elements.push(
        <MDBCard className="my-1" key={"cid-" + elem.collapseId}>
          <MDBCollapseHeader
            className="grey lighten-3"
            onClick={this.mobileToggleCollapse(elem.collapseId)}
          >
            <span className="">{elem.title}</span>
            <MDBIcon
              icon={collapseID === elem.collapseId ? "angle-up" : "angle-down"}
              className=""
              style={{ float: "right" }}
            />
          </MDBCollapseHeader>
          <MDBCollapse id={elem.collapseId} isOpen={collapseID}>
            <MDBTable bordered>{elem.elem}</MDBTable>
          </MDBCollapse>
        </MDBCard>
      );
    });

    return (
      <div>
        {/* <h5 className="mb-3">Please select date</h5> */}
        {elements}
        {!this.state.isScrolling && this.mobileActionButton()}
      </div>
    );
  }

  mobileBuildTableElem(generatedTimeContainer, userCalendarContainer) {
    const { collapseID } = this.state;
    let genTimeCount = generatedTimeContainer.length + 1;
    let generatedTimeArr = generatedTimeContainer;
    let tableElem = [];

    let calendarView = this.state.switchCalendar ? 1 : 7;
    let totalResult = calendarView + 2;
    let results = userCalendarContainer.data.bookings.results;

    let thNameArr = this.getDays(this.state.switchCalendar);

    _.map(thNameArr, (thN, index) => {
      let tableBodyElem = [];
      for (let i = 0; i < genTimeCount; i++) {
        let thElem = [];
        let tbHeadElem = [];
        for (let j = 0; j < 2; j++) {
          if (i > 0) {
            if (j === 0) {
              thElem.push(
                this.renderTD(generatedTimeArr[i - 1], "td-" + i + "-" + j, 20)
              );
            } else {
              let paramData = {
                court: thNameArr[j - 1].dayName,
                bookings: results,
                date: thNameArr[j - 1].date,
                time: generatedTimeArr[i - 1],
                key: "td-" + i + "-" + j,
              };
              thElem.push(this.validateRenderingOfTD(paramData));
            }

            if (j === 1) {
              tbHeadElem.push(
                <tr
                  className={`text-center ${
                    this.state.private && i % 2 === 0
                      ? "table-border-bottom-dotted"
                      : ""
                  }`}
                  key={"bodyTr-" + i + "-" + j}
                >
                  {thElem}
                </tr>
              );
              tableBodyElem.push(tbHeadElem);
              thElem = [];
              tbHeadElem = [];
            }
          }
        }
      }

      tableElem.push({
        collapseId: "collapse-" + index,
        title: thNameArr[index].dayName,
        elem: tableBodyElem,
      });
    });
    return tableElem;
  }

  renderMobileViewContainer() {
    return (
      <div className="mobile-view">
        <MDBTable bordered>
          <MDBTableHead>
            <tr>
              <th>{this.mobileHeaderSection()}</th>
            </tr>
          </MDBTableHead>
          <MDBTableBody>
            <tr>
              <td>{this.mobileResourceAcordtion()}</td>
            </tr>
          </MDBTableBody>
        </MDBTable>
      </div>
    );
  }

  // -------------------- MOBILE CODES ------------------ //

  getDays(isDay) {
    let arrDay = [];
    if (!isDay) {
      var startOfWeek = moment(this.props.selectedDate)
        .startOf("isoWeek")
        .format("YYYY-MM-DD");
      arrDay.push({
        dayName: moment(startOfWeek, "YYYY-MM-DD")
          .local(this.getTzDetails().timezone)
          .format("ddd MMM DD"),
        date: startOfWeek,
      });
      for (let i = 1; i <= 6; i++) {
        let d = moment(startOfWeek, "YYYY-MM-DD")
          .add(i, "days")
          .format("YYYY-MM-DD");
        arrDay.push({
          dayName: moment(d, "YYYY-MM-DD")
            .local(this.getTzDetails().timezone)
            .format("ddd MMM DD"),
          date: d,
        });
      }
    } else {
      arrDay = [
        {
          dayName: moment(this.props.selectedDate)
            .local(this.getTzDetails().timezone)
            .format("ddd MMM DD"),
          date: moment(this.props.selectedDate)
            .local(this.getTzDetails().timezone)
            .format("YYYY-MM-DD"),
        },
      ];
    }
    return arrDay;
  }

  buildTableElem(generatedTimeContainer, userCalendarContainer) {
    let genTimeCount = generatedTimeContainer.length + 1;
    // let totalResult = locationResourcesContainer.results.length + 2;
    let calendarView = this.state.switchCalendar ? 1 : 7;
    let totalResult = calendarView + 2;
    let results = userCalendarContainer.data.bookings.results;
    let generatedTimeArr = generatedTimeContainer;
    let tableElem = [];
    let tableBodyElem = [];
    let maxWidth = 76;
    let tdWidth = maxWidth / calendarView;
    this.popupStatusClass = "";

    let thNameArr = this.getDays(this.state.switchCalendar);
    if (tdWidth < 21) {
      this.popupStatusClass = "popup-status";
    }

    for (let i = 0; i < genTimeCount; i++) {
      let thElem = [];
      let tbHeadElem = [];
      for (let j = 0; j < totalResult; j++) {
        //-- build header
        if (i === 0) {
          if (j === 0 || j === totalResult - 1) {
            thElem.push(
              this.renderTHNav(
                "",
                "th-" + i + "-" + j,
                "fix-size-calendar-timeslot",
                j === 0 ? false : true
              )
            );
          } else {
            thElem.push(
              this.renderTH(
                thNameArr[j - 1].dayName,
                "th-" + i + "-" + j,
                "",
                tdWidth
              )
            );
          }

          if (j === totalResult - 1) {
            tbHeadElem.push(
              <MDBTableHead key={"tableHead1-" + i + "-" + j}>
                <tr key={"tr1-" + i + "-" + j}>
                  <th colSpan={totalResult}>{this.headerSection()}</th>
                </tr>
                <tr
                  key={"tr2-" + i + "-" + j}
                  className={`text-center ${
                    this.state.private ? "table-border-bottom-dotted" : ""
                  }`}
                >
                  {thElem}
                </tr>
              </MDBTableHead>
            );
            tableElem.push(tbHeadElem);
            thElem = [];
            tbHeadElem = [];
          }
        } else {
          if (j === 0 || j === totalResult - 1) {
            thElem.push(
              this.renderTD(generatedTimeArr[i - 1], "td-" + i + "-" + j)
            );
          } else {
            let paramData = {
              bookings: results,
              // court: results[j - 1].name,
              // bookings: results[j - 1].bookings,
              date: thNameArr[j - 1].date,
              time: generatedTimeArr[i - 1],
              key: "td-" + i + "-" + j,
              // maxBookingParticipants:
              //   results[j - 1].attributes.max_participants,
              // defaultStartTime: results[j - 1].attributes.default_start_time,
              // defaultEndTime: results[j - 1].attributes.default_end_time,
              // resourceUuid: results[j - 1].uuid,
              // resourceId: results[j - 1].id,
              // durationPerChunk: results[j - 1].attributes.duration_per_chunk,
              // maxDuration: results[j - 1].attributes.max_duration,
              // minDuration: results[j - 1].attributes.min_duration,
              // locked: results[j - 1].locked,
              // recurrings: results[j - 1].recurrings,
              // allowBookingSameTime:
              //   typeof results[j - 1].attributes.book_at_same_time ==
              //   "undefined"
              //     ? ""
              //     : results[j - 1].attributes.book_at_same_time,
              // allowStartTime:
              //   typeof results[j - 1].attributes.allowed_start_time ==
              //   "undefined"
              //     ? ""
              //     : parseInt(
              //         results[j - 1].attributes.allowed_start_time.replace(
              //           ":",
              //           ""
              //         )
              //       ),
              // allowEndTime:
              //   typeof results[j - 1].attributes.allow_end_time == "undefined"
              //     ? ""
              //     : parseInt(
              //         results[j - 1].attributes.allow_end_time.replace(":", "")
              //       ),
            };
            thElem.push(this.validateRenderingOfTD(paramData));
          }

          if (j === totalResult - 1) {
            tbHeadElem.push(
              <tr
                className={`text-center ${
                  this.state.private && i % 2 === 0
                    ? "table-border-bottom-dotted"
                    : ""
                }`}
                key={"bodyTr-" + i + "-" + j}
              >
                {thElem}
              </tr>
            );
            tableBodyElem.push(tbHeadElem);
            thElem = [];
            tbHeadElem = [];
          }
        }
      }
    }

    tableElem.push(
      <MDBTableBody key={"body-key"}>{tableBodyElem}</MDBTableBody>
    );

    return tableElem;
  }

  doGoToToday() {
    let date = new Date();
    this.props.selectDate(date);
    this.setState({
      isClientSideFilter: false,
      ClientSidefilterCompleted: false,
      locationResourcesLoaded: false,
    });
    this.debouncedSelectedDate(date);
    this.doSwitchCalendar(this.state.switchCalendar, date);
  }

  renderContent() {
    const { courtTypeOptions, surfaceTypeOptions, tableElemForMobile } =
      this.state;
    const { browserSize } = this.props;

    if (
      this.state.generatedTimeContainer.length > 0 &&
      browserSize.lessThan.medium &&
      tableElemForMobile
    ) {
      return (
        <div
          className={`mobile-view weeklycalendar-mobile  ${
            courtTypeOptions.length > 2 ? "ct" : ""
          } ${surfaceTypeOptions.length > 2 ? "st" : ""}`}
        >
          {this.renderMobileViewContainer()}
        </div>
      );
    }

    if (
      this.state.generatedTimeContainer.length > 0 &&
      !browserSize.lessThan.medium &&
      !tableElemForMobile
    ) {
      return (
        <div>
          <MDBTable
            bordered
            className={`${this.popupStatusClass} weeklycalendar mycalendar ${
              courtTypeOptions.length > 2 ? "ct" : ""
            } ${surfaceTypeOptions.length > 2 ? "st" : ""}`}
          >
            {this.state.tableElem}
          </MDBTable>
        </div>
      );
    } else if (
      this.state.locationResourcesLoaded &&
      this.state.generatedTimeContainer.length === 0
    ) {
      return (
        <div className="text-center">
          <h5>No resource found.</h5>
        </div>
      );
    }
    return <div className="text-center">Loading...</div>;
  }

  revalidateComponent() {
    let params = queryString.parse(this.props.location.search);
    // this.props.getLocationResources(params.uuid, this.state.searchDateVal);
    return <span></span>;
  }

  render() {
    return (
      <div>
        <IdleTimer
          ref={(ref) => {
            this.idleTimer = ref;
          }}
          timeout={1000 * 60 * 5}
          onActive={this.handleOnActive}
          onIdle={this.handleOnIdle}
          onAction={this.handleOnAction}
          debounce={250}
        />
        {this.renderBookingDetailsForm()}
        {this.renderContent()}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    modal: state.modal,
    locationResources: state.locationResources,
    selectedDate: state.selectedDate,
    locations: state.locations,
    bookingDetails: state.bookingDetails,
    authUser: state.authUser,
    paymentRequestSuccess: state.paymentRequestSuccess,
    paymentRequestFailed: state.paymentRequestFailed,
    bookingSuccessResponse: state.bookingSuccessResponse,
    bookingFailedResponse: state.bookingFailedResponse,
    successHandlerResponse: state.successHandlerResponse,
    failedHandlerResponse: state.failedHandlerResponse,
    getStatusesSuccessResponse: state.getStatusesSuccessResponse,
    getStatusesFailedResponse: state.getStatusesFailedResponse,
    getBookingStatusSuccessResponse: state.getBookingStatusSuccessResponse,
    getBookingStatusFailedResponse: state.getBookingStatusFailedResponse,
    genCustomerVoucherSuccessResponse: state.genCustomerVoucherSuccessResponse,
    genCustomerVoucherFailedResponse: state.genCustomerVoucherFailedResponse,
    getLocationListSuccessResponse: state.getLocationListSuccessResponse,
    getLocationListFailedResponse: state.getLocationListFailedResponse,
    customerResponse: state.customerResponse,
    isCloseBooking: state.closeBooking,
    bookingResponse: state.bookingResponse,
    browserSize: state.browserSize,
    storeUserAccess: state.storeUserAccess,
    userResponse: state.userResponse,
    getResourceResponse: state.resourceResponse,
  };
};

export default withRouter(
  connect(mapStateToProps, {
    toggleModal,
    // getLocationResources,
    selectDate,
    searchLocations,
    setBookingDetails,
    showHideLoader,
    // getLocationResourcesPrivate,
    requestPayment,
    clearBookingSuccessResponse,
    clearBookingFailedResponse,
    doBooking,
    updateBooking,
    calculatePrice,
    getStatuses,
    clearStatusSuccessResponse,
    clearStatusFailedResponse,
    getBookingStatus,
    clearBookingStatusSuccessResponse,
    clearBookingStatusFailedResponse,
    generateCustomerVoucher,
    clearGenCustomerVoucherSuccessResponse,
    clearGenCustomerVoucherFailedResponse,
    getLocationList,
    showNotification,
    clearNotification,
    getCustomers,
    closeBooking,
    bookingChangeSchedule,
    checkBookingConflicts,
    subscribe,
    getUserCalendar,
    getResource,
  })(MyCalendar)
);
